import Navigation from './_navigation';
import Dialogs from './_dialogs';
import CommentBox from './_comment_box';
import JoyrideConfig from './onboarding/_joyride_config';
import ToastMessage from './_toast_message';
import ErrorPage from './_error_page';
import DownloadMobileBanner from './_download_mobile_banner';
import ModalSingleCardView from './editor/_modal_single_card_view';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {DndProvider} from 'react-dnd';

import {routes, redirects} from '../modules/routing/routes';
import {getRouteParams, redirectConsumersToV2, redirectCuratorsToV2, redirectToV2} from '../modules/route_utils';
import {setCaxiosDefaults, fetch, post, destroy, update} from '../modules/api_utils';
import {userIsKluebot, userIsAdmin, userCanCurate} from '../modules/roles_utils';
import {clearAuthSuccessful, mergeExtendedUserProperties, setAuthSuccessful, sortUsers, setIsKluebeeCookie} from '../modules/user_utils';
import {userGet, userUpdate} from '../modules/api/users';
import {rivalsGet, rivalGet} from '../modules/api/rivals';
import {rivalGroupsGet, rivalGroupGet} from '../modules/api/rival_groups';
import {profileUpdate} from '../modules/api/profiles';
import {notificationsCountsGet} from '../modules/api/notifications';
import {clearStaleLSRecords} from '../modules/local_storage_utils';
import {arrayIsEqual, dig, wait, isValidId, serializeQueryString} from '../modules/utils';
import {isChrome, isChromiumEdge, isMobileBrowser} from '../modules/browser_utils';
import {isAndroidOriOSBrowser, isAndroidBrowser} from '../modules/mobile_utils';
import {filterRemindableDigests, getDigestReminderMessage} from '../modules/digest_utils';
import {uiDefaultTypes, uiMessages, uiMessageTypes} from '../modules/constants/ui';
import * as analyticsSettings from '../modules/constants/analytics';
import {analyticsInit, analyticsTrack} from '../modules/analytics_utils';
import {RIVALS_PER_PAGE, DIGESTS_PER_PAGE, NOTIFICATIONS_FETCH_INTERVAL} from '../modules/constants/api';
import {putMobileBannerDismissedToLS, getMobileBannerDismissedFromLS} from '../modules/local_storage_utils';
import {sendMessageToExtensionBackground} from '../modules/ext_utils';
import {APP_STORE_URL, PLAY_STORE_URL, GET_FROM_APP_STORE_MESSAGE, GET_FROM_PLAY_STORE_MESSAGE} from '../modules/constants/mobile';
import sessionManager from '../modules/session_manager';

import ReactUpdate from 'immutability-helper';
import {Notifier} from '@airbrake/browser';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import {Route, Switch, Redirect, withRouter} from 'react-router-dom';
import {TagsProvider} from '../contexts/_tags';
import {PostsProvider} from '../contexts/_posts';

class AppBase extends React.Component {

  static childContextTypes = {
    appData: PropTypes.object.isRequired,
    api: PropTypes.object.isRequired,
    utils: PropTypes.object.isRequired,
    joyride: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  };

  static propTypes = {
    appData: PropTypes.object.isRequired,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    children: PropTypes.node,
    joyAPI: PropTypes.func,
    joyride: PropTypes.object,
    setJoyride: PropTypes.func,
    setJoyrideFlags: PropTypes.func,
    joyrideFlags: PropTypes.object
  };

  static defaultProps = {
    appData: {},
    match: {},
    history: {},
    location: null,
    children: null,
    joyAPI() {},
    joyride: null,
    setJoyride() {},
    setJoyrideFlags() {},
    joyrideFlags: null
  };

  state = {
    currentUser: (this.props.appData || {}).user || {},         // only initial population is from props
    currentCompany: (this.props.appData || {}).company || {},   // same as above
    users: null,
    rivals: null,
    rival: null,
    rivalsRequestQueue: [],
    totalRivals: 0,
    rivalGroups: null,
    notificationsCount: 0,
    staleBattlecardsCount: 0,
    dialogs: [],
    toastMessages: [],
    joyride: {},
    visibilityGroups: null,
    didUpdateMobileBannerStatus: false
  };

  getChildContext() {
    // Klue extension does not load _app_base but shares code with the app
    // api & utils context are provided in _extension_box
    // todo Extract shared context
    return {
      appData: this.props.appData,
      utils: {
        user: this.state.currentUser,
        company: this.state.currentCompany,
        rival: this.getActiveRival(),
        rivalSet: this.setContextRival,
        getActiveRival: this.getActiveRival,
        battlecard: this.getActiveBattlecard(),
        getCurrentLocation: this.getCurrentLocation,
        requestUser: this.requestUser,
        requestRival: this.requestRival,
        requestRivals: this.requestRivals,
        getCuratorsForContainer: this.getCuratorsForContainer,
        getCollapsedLanes: this.getCollapsedLanes,
        userIsKluebot: this.userIsKluebot,
        userIsStaff: this.userIsStaff,
        userIsAdmin: this.userIsAdmin,
        userCanCurate: this.userCanCurate,
        featureFlags: this.featureFlags(),
        hasBattlecard: this.hasBattlecard,
        isOnBattlecard: this.isOnBattlecard,
        canAddToBattlecard: this.canAddToBattlecard,
        refreshRivalProfile: this.refreshRivalProfile,
        getBattlecardTemplate: this.getBattlecardTemplate,
        getBattlecardTitle: this.getBattlecardTitle,
        getNotificationCounts: this.getNotificationCounts,
        getKlueUrl: this.getKlueUrl,
        canLoadExtension: this.canLoadExtension,
        dialog: this.dialog,
        companyDataUpdate: this.companyDataUpdate,
        companyDataLoad: this.companyDataLoad,
        handleCreateProfileCommentClick: this.handleCreateProfileCommentClick,
        showAjaxTimeoutErrorMessage: this.showAjaxTimeoutErrorMessage,
        embedHtmlDynamicCardsEnabled: this.isEmbedHtmlDynamicCardsEnabled,
        visibilityGroups: this.state.visibilityGroups,
        assignVisibilityGroupViaSSO: this.isAssignVisibilityGroupViaSSOFeatureEnabled,
        cardTagIsVisible: this.isCardTagVisible,
        printBattlecardDisabled: this.printBattlecardDisabled,
        suppressionNotificationDisabled: this.suppressionNotificationDisabled,
        automatedDataFeedbackReportingDisabled: this.automatedDataFeedbackReportingDisabled,
        isCardEditorLinkSelectorDisabled: this.isCardEditorLinkSelectorDisabled,
        isDisableDigestPreviewSend: this.isDisableDigestPreviewSend,
        isDigestMultiplesEnabled: this.isDigestMultiplesEnabled
      },
      api: {
        // mapping: AppBase.api[Model][Method] => this.context.api.[model][Method]
        rivalsGet: this.apiRivalsGet,
        rivalGet: this.apiRivalGet,
        rivalCreate: this.apiRivalCreate,
        rivalDelete: this.apiRivalDelete,
        refreshGroupsForRival: this.refreshGroupsForRival,
        rivalGroupsGet: this.apiRivalGroupsGet,
        rivalGroupGet: this.apiRivalGroupGet,
        rivalGroupCreate: this.apiRivalGroupCreate,
        rivalGroupUpdate: this.apiRivalGroupUpdate,
        rivalGroupDelete: this.apiRivalGroupDelete,
        battlecardsGet: this.apiBattlecardsGet,
        battlecardCreateOrUpdate: this.apiBattlecardCreateOrUpdate,
        battlecardDelete: this.apiBattlecardDelete,
        profileUpdate: this.apiProfileUpdate,
        profileClone: this.apiProfileClone,
        postsGet: this.apiPostsGet,
        postGet: this.apiPostGet,
        postCommentsGet: this.apiPostCommentsGet,
        postCompetitorTagUpdate: this.apiPostCompetitorTagUpdate,
        digestsGet: this.apiDigestsGet,
        digestGet: this.apiDigestGet,
        digestCreate: this.apiDigestCreate,
        digestPreview: this.apiDigestPreviewGet,
        digestUpdate: this.apiDigestUpdate,
        digestDelete: this.apiDigestDelete,
        digestPreviewSend: this.apiDigestPreviewSend,
        digestTypesGet: this.apiDigestTypesGet,
        digestTypeGet: this.apiDigestTypeGet,
        digestTypeCreate: this.apiDigestTypeCreate,
        digestTypeUpdate: this.apiDigestTypeUpdate,
        digestTypeDelete: this.apiDigestTypeDelete,
        digestFavoritesGet: this.apiDigestFavoritesGet,
        favoritesGet: this.apiFavoritesGet,
        favoritesUpdateBatch: this.apiFavoritesUpdateBatch,
        favoriteCreate: this.apiFavoriteCreate,
        favoriteUpdate: this.apiFavoriteUpdate,
        favoriteDelete: this.apiFavoriteDelete,
        usersGet: this.apiUsersGet,
        userGet: this.apiUserGet,
        userUpdate: this.apiUserUpdate,
        userDelete: this.apiUserDelete,
        userReconfirm: this.apiUserReconfirm,
        companyGet: this.apiCompanyGet,
        companyUpdate: this.apiCompanyUpdate,
        metabaseQueriesGet: this.apiMetabaseQueriesGet,
        monitorsGet: this.apiMonitorsGet,
        monitorGet: this.apiMonitorGet,
        monitorContentsGet: this.apiMonitorContentsGet,
        monitorDelete: this.apiMonitorDelete,
        search: this.apiSearch,
        visibilityGroupsGet: this.apiVisibilityGroupsGet,
        visibilityGroupCreate: this.apiVisibilityGroupCreate,
        visibilityGroupUpdate: this.apiVisibilityGroupUpdate,
        visibilityGroupDelete: this.apiVisibilityGroupDelete
      },
      joyride: {
        toggleJoyride: this.toggleJoyride,
        setJoyride: this.props.setJoyride,
        setJoyrideFlags: this.props.setJoyrideFlags,
        joyrideFlags: this.props.joyrideFlags
      },
      location: this.props.location
    };
  }

  componentDidMount() {
    console.log('AppBase.componentDidMount: props: %o, context: %o', this.props, this.context);

    // TODO: remove this flag after migrating state management (also applies to all child components)
    this._isMounted = true;

    const {appData = {}} = this.props;
    const params = getRouteParams(this.props, '/profile/:profileId');
    const profileId = parseInt(params.profileId, 10) || 0;
    const location = this.getCurrentLocation();
    const isProfileView = location.startsWith('/profile');

    // Trigger a reload of any iframes awaiting auth
    setAuthSuccessful();
    setIsKluebeeCookie(appData?.user?.email);

    if(isValidId(profileId)) {
      this.requestRival({profileId});
    }

    if(!_.isEmpty(appData)) {
      console.log('AppBase.componentDidMount: appData: %o', appData);

      const {initSessionConfig} = sessionManager();

      initSessionConfig({
        onResetSessionExpirationDate: async () => {
          // perform a dummy API call to reset the expiration date
          await fetch('/api/users/me.json');

          // call notifications again to refresh the token immediately after the previous API call
          this.initNotificationsFetch();
        },
        enqueueToastMessage: this.enqueueToastMessage,
        clearToastMessages: this.clearToastMessages,
        onSignOut: async () => {
          const formData = new FormData();

          formData.set('_method', 'DELETE');
          formData.set('authenticity_token', this.state.currentUser.csrf);

          clearAuthSuccessful();

          await post(appData.signOutUrl, formData, {
            headers: {'Content-Type': 'multipart/form-data'}
          }).then(() => {
            // reload to redirect to sign in again
            window.location.reload();
          });
        }
      });

      this.initAirbrake();

      const currentUser = mergeExtendedUserProperties(appData.user);
      const {isImpersonating = false, isStaff = false, isInternal = false, roles = []} = currentUser;

      sendMessageToExtensionBackground({type: 'klue:app:user:roles', body: {isImpersonating, isStaff, isInternal, roles}})
        .catch(error => error && console.error(error));
      this.setState({
        currentUser,
        users: {[currentUser.id]: currentUser}    // populate first entry in users object with current user
      }, () => {
        console.log('AppBase.componentDidMount: populated users: %o', this.state.users);

        // check that user has proper permissions for current route
        this._redirectInvalidRoles(location);

        // TODO: What happens if the passed CSRF becomes invalid?
        // In other places in the app where `csrf` token is used, it's fed via `props.user` which theoretically stays up-to-date (it's not).
        // In case with utils file - it's stateless, so I don't know what I will be doing here. I think, inside the `app_base` if it can be detected
        // that `state.currentUser.csrf` was changed, then updated value can be passed to api utils.
        setCaxiosDefaults(this.state.currentUser.csrf, {
          enqueueToastMessage: this.enqueueToastMessage,
          clearToastMessages: this.clearToastMessages
        });
      });

      const {flashMessages, helpDocsHost} = appData;

      flashMessages.map((flashMessage = []) => {
        // Extract message ID from flash message string
        const [msgLevel, msgBody] = flashMessage;
        const [, msgId] = msgBody.match(/^\[([^\]]+)\]/) || [];
        const msg = (msgId && uiMessages({id: msgId}))
          ? uiMessages({id: msgId, messageData: {helpDocsHost}})
          : {
            title: uiMessageTypes[msgLevel.toUpperCase()] || uiMessageTypes.NOTICE,
            message: msgBody,
            duration: 0,
            isError: Boolean(msgLevel === 'alert')
          };
        const {title = '', message = '', isError = false, duration = 0, messageId = msgId} = msg;

        if(title && message) {
          this.enqueueToastMessage({
            title,
            message,
            duration,
            isError,
            source: 'AppBase',
            messageId
          });
        }
      });

      this.apiRivalGroupsGet();         // required on all routes (needed by left navigation)
      this.initNotificationsFetch();
      clearStaleLSRecords();
      this.analyticsInit();
      this.attachOfflineStatusListener();

      if(!isProfileView) {
        this.triggerPageTrack(location);
      }

      this.digestRemind(location);
    }
  }

  componentWillUnmount() {
    this.clearNotificationsTimer();
    this._isMounted = false;
  }

  // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {location: prevLocation} = this.props;
    const {location: nextLocation} = nextProps;
    const params = getRouteParams(nextProps, '/profile/:profileId');
    const profileId = parseInt(params.profileId, 10) || 0;
    const location = this.getCurrentLocation(nextLocation);
    const isProfileView = location.startsWith('/profile');

    if(isValidId(profileId)) {
      this.requestRival({profileId});
    }

    // check that user has proper permissions for current route
    this._redirectInvalidRoles(location);

    if((prevLocation !== '/') && (this.getCurrentLocation(prevLocation) !== location)) {
      if(!isProfileView) {
        this.triggerPageTrack(location);
      }
    }
  }

  // custom dialogs
  dialog = {
    alert() {},
    confirm() {},
    confirmRestrictive() {},
    create() {},
    getNewId() {},
    remove() {}
  };

  _maxBattlecardCards = 8;
  _airbrakeClient = null;

  _preventDefault = e => e && e.preventDefault();

  _redirectInvalidRoles = (location = '') => {
    if(!location) {
      return;
    }

    // TODO: investigate refactoring role checks to react-router user auth flow described below:
    // http://stackoverflow.com/a/33796304/226756
    // https://github.com/ReactTraining/react-router/blob/efac1a8ff4c26d6b7379adf2ab903f1892276362/examples/auth-flow/app.js#L122
    if(!this.userCanCurate() && (
      location.startsWith('/alerts') || location.startsWith('/monitors') || location.startsWith('/settings') || location === '/users'
    )) {
      // consumer user doesn't have permission to view route, boot back to feed
      console.warn('AppBase._redirectInvalidRoles: failed role check for route: %o, redirecting to default route', location);

      this.props.history.replace({
        pathname: '/',
        state: {
          redirectCode: 'userIsRestricted'
        }
      });
    }
  };

  attachOfflineStatusListener = () => {
    const updateOnlineStatus = () => {
      if(!navigator.onLine) {
        this.enqueueToastMessage({
          title: 'You appear to be offline 😢',
          message: 'Please check your network connection and refresh your browser.',
          isInfo: true,
          duration: 0,  // infinite
          source: 'AppBase'
        });
      }
      else {
        this.clearToastMessages('AppBase');
      }
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
  };

  initAirbrake = () => {
    const {appData: {env, airbrakeProjectId: projectId, airbrakeApiKey: projectKey}} = this.props;

    if(!projectId || !projectKey) {
      console.warn(
        'AppBase.initAirbrake: invalid airbrake parameters, skipping: projectId: %o, projectId: %o', projectId, projectKey
      );

      return;
    }

    // projectId & projectKey come from airbrake.io => project settings
    try {
      this._airbrakeClient = new Notifier({projectId, projectKey, environment: env});
    }
    catch(err) {
      console.warn('AppBase.initAirbrake: initialization failed for projectId=%o projectKey=%o: %o', projectId, projectKey, err);

      return;
    }

    if(!this._airbrakeClient) {
      console.error('AppBase.initAirbrake: error initializing airbrake client: env: %o, projectId: %o, projectKey: %o',
        env, projectId, projectKey
      );

      return;
    }

    this._airbrakeClient.addFilter(notice => {
      const {errors: [error = {}] = []} = notice;
      const squelched = [
        'Request failed with status code 401',
        'Network Error'
      ];

      // we ignore certain high volume errors generated via JS Error object
      if(error.type === 'Error' && squelched.indexOf(error.message) !== -1) {
        console.warn('AppBase.initAirbrake: squelched notice for projectId=%o projectKey=%o: %o', projectId, projectKey, notice);

        return null;
      }

      console.warn('AppBase.initAirbrake: submitting notice for projectId=%o projectKey=%o: %o', projectId, projectKey, notice);

      return notice;
    });

    console.log('AppBase.initAirbrake: env: %o, projectId: %o, projectKey: %o, airbrake client initialized: %o',
      env, projectId, projectKey, this._airbrakeClient
    );
  };

  getUIDefaults = (type = null) => {
    const {currentCompany: company, currentUser: user} = this.state;

    if(_.isEmpty(company) || _.isEmpty(user)) {
      // potentially in mid-load
      return {};
    }

    // set personalized/company defaults for groups/sort
    const {companyData} = company || {};
    const {userData} = user || {};
    let defaults = {};

    if(type && Object.values(uiDefaultTypes).includes(type)) {
      if(userData && userData.defaults && userData.defaults[type]) {
        // personalized user configuration trumps company-wide defaults
        defaults = userData.defaults[type];
      }
      else if(companyData && companyData.defaults && companyData.defaults[type]) {
        // if company defaults are available, use them instead
        defaults = companyData.defaults[type];
      }
    }
    else if(userData && userData.defaults) {
      defaults = userData.defaults;
    }
    else if(companyData && companyData.defaults) {
      defaults = companyData.defaults;
    }

    console.log('AppBase.getUIDefaults: loaded UI defaults: %o', defaults);

    return defaults;
  };

  analyticsInit = () => {
    const {currentUser: user, currentCompany: company} = this.state;
    const {appData: {staffUser, company: appCompany, env, klueAnalyticsId, spAnalyticsId, spAnalyticsPath, spAnalyticsUrl, spAnalyticsLegacy} = {}} = this.props;
    const debug = analyticsSettings.DEBUG_ANALYTICS;
    const companyAnalyticsSettings = dig(company, 'companyData.analytics');

    // replace with environment variable
    const {ga = {}} = companyAnalyticsSettings || {};
    const accounts = [];

    // Instance GA account
    if(ga && ga.trackingId) {
      accounts.push({
        name: 'instanceAccount',
        provider: 'ga',
        id: ga.trackingId,
        debug: ga.debug || debug
      });
    }

    // configured Klue GA account
    if(klueAnalyticsId) {
      accounts.push({
        name: 'klueCustomersAccount',
        provider: 'ga',
        id: klueAnalyticsId,
        debug
      });
    }

    if(spAnalyticsId && spAnalyticsUrl) {
      accounts.push({
        name: 'instanceAccount',
        provider: 'sp',
        appId: spAnalyticsId,
        collectorUrl: spAnalyticsUrl,
        postPath: spAnalyticsPath
      }, {
        name: 'LegacyInstanceAccount',
        provider: 'sp',
        appId: spAnalyticsId,
        collectorUrl: spAnalyticsUrl,
        postPath: spAnalyticsPath
      });
    }

    analyticsInit({
      user,
      company,
      accounts,
      spAnalyticsLegacy
    });
  };

  triggerPageTrack = location => {
    const pageTrackingTypes = ['pageping', 'pageview'];

    pageTrackingTypes.forEach(type => {
      analyticsTrack({
        path: `${location}${window.location.search}`,
        type
      });
    });
  };

  setNotificationsTimer = () => {
    this.clearNotificationsTimer();

    if(this._isMounted) {
      // auto-refresh notifications every 5 minutes
      this._notificationsTimer = setInterval(this.refreshNotificationsCount, NOTIFICATIONS_FETCH_INTERVAL);
    }

    return this._notificationsTimer;
  };

  clearNotificationsTimer = () => {
    if(this._notificationsTimer) {
      clearInterval(this._notificationsTimer);
      this._notificationsTimer = null;
    }
  };

  initNotificationsFetch = () => {
    return new Promise(async resolve => {
      await this.refreshNotificationsCount();
      resolve(this.setNotificationsTimer());
    });
  };

  refreshNotificationsCount = () => {
    const {env, packPaths: currentPackPaths, user} = (this.props.appData || {});

    return new Promise(async resolve => {
      const {notificationsCount, staleBattlecardsCount, packPaths, sessionAbsoluteTimeoutAt, sessionIdleTimeoutAt} = await notificationsCountsGet({ownProfiles: true});
      const {setSessionExpirationDate} = sessionManager();

      /**
       * NOTE:
       * Notifications API returns the expiration date for the user session.
       * Every request will update these values in the session manager.
       */
      setSessionExpirationDate({sessionAbsoluteTimeoutAt, sessionIdleTimeoutAt});

      // check to see if release version has changed since the current user loaded the app;
      // if so, prompt/force a reload of the front-end (#3157)
      if(!_.isEqual(currentPackPaths, packPaths) && (env !== 'development')) {
        // NOTE:
        // - webpacker hash digest default length is 20 characters (hex) for JS, 8 characters for CSS
        //   https://webpack.js.org/configuration/output/#output-hashdigestlength
        // - webpacker pack path format is: '{webpackPackPath}/{filename}-{hash}.[js|css]'
        // - we currently use 3 different packs (application, extension, and salesforce), but only application can trigger an app reload
        this.clearNotificationsTimer();

        console.warn('AppBase.refreshNotificationsCount: app version has changed, please reload!', packPaths);

        const {title, message} = uiMessages({id: 'newVersion'});

        if(title && message) {
          this.enqueueToastMessage({
            title,
            message,
            duration: 0,
            isInfo: true,
            source: 'AppBase',
            onDismissClick: () => window.location.reload()    // force full reload even on toast dismissal 😈
          });

          // force refresh after the notifications fetch interval, even if user hasn't seen the toast message
          await wait(NOTIFICATIONS_FETCH_INTERVAL);

          console.warn(`AppBase.refreshNotificationsCount: waited ${NOTIFICATIONS_FETCH_INTERVAL}ms, force-reloading the app`);

          window.location.reload();
        }
      }

      // normal notifications fetch, carry on as usual
      this.setState({
        notificationsCount,
        staleBattlecardsCount
      }, () => {
        resolve({
          notificationsCount,
          staleBattlecardsCount
        });
      });

      // Piggybacking off notifications ping to update extension with user permissions
      const {isImpersonating = false, isStaff = false, isInternal = false, roles = []} = user;

      sendMessageToExtensionBackground({type: 'klue:app:user:roles', body: {isImpersonating, isStaff, isInternal, roles}})
        .catch(error => error && console.error(error));
    });
  };

  digestRemind = (location = '') => {
    const {currentCompany: company, currentUser: user} = this.state;

    if(location.startsWith('/digest') || location.startsWith('/feed')) {
      return this.clearToastMessages('AppBase.digestRemind');
    }

    if(userCanCurate({user})) {
      const digestFrequency = company.defaultDigestType.reviewFrequency;

      if(digestFrequency !== 'daily') {
        const digestOptions = {
          page: 1,
          typeId: 'all',
          limit: 20,
          filter: 'draft'
        };

        this.apiDigestsGet({digestOptions, code: 'Digest.loadDigests', callback: ({digests}) => {
          const activeDigests = this.isDigestMultiplesEnabled()
            ? digests
            : digests.filter(digest => digest.digestType?.default === true);
          const filteredDigests = filterRemindableDigests(activeDigests);

          if(filteredDigests.length < 1) {
            return;
          }

          const digestData = dig(user, 'userData.digest', {});
          const filteredDigestIds = filteredDigests.map(filteredDigest => filteredDigest.id);
          let notPreviouslyDismissed;

          if(!this.isDigestMultiplesEnabled()) {
            const {id} = activeDigests[0] || {};

            notPreviouslyDismissed = digestData.reminderDismissed !== id;
          }
          else {
            if(!digestData.hasOwnProperty('multiReminderDismissed')) {
              digestData.multiReminderDismissed = [];
            }

            notPreviouslyDismissed = !arrayIsEqual(filteredDigestIds, digestData.multiReminderDismissed);
          }

          const onDismissClick = () => {
            const {id} = activeDigests[0] || {};

            if(!this.isDigestMultiplesEnabled()) {
              digestData.reminderDismissed = id;
            }
            else {
              digestData.multiReminderDismissed = filteredDigestIds;
            }

            const userData = _.extend({}, user.userData, {digest: digestData});

            this.clearToastMessages('AppBase.digestRemind');
            this.apiUserUpdate({id: user.id, userData});
          };

          const message = getDigestReminderMessage(filteredDigests, this.isDigestMultiplesEnabled(), onDismissClick);

          if(notPreviouslyDismissed && message) {
            this.clearToastMessages('AppBase.digestRemind');
            this.enqueueToastMessage({
              title: '✋ Don\'t forget the digest!',
              message,
              duration: 0,
              source: 'AppBase.digestRemind',
              onDismissClick
            });
          }
          else {
            this.clearToastMessages('AppBase.digestRemind');
          }

          return message || null;
        }});
      }
    }
  };

  /*
   * UTILS (this.context.utils)
   * shared domain-specific utilities, accessible via context
   */

  getActiveRival = () => {
    const {rivals, rival} = this.state;
    const params = getRouteParams(this.props, '/profile/:profileId');

    if(rival) {
      return rival;
    }

    if(_.isEmpty(params) || !params.profileId || _.isEmpty(rivals)) {
      return null;
    }

    const profileId = parseInt(params.profileId, 10) || 0;

    if(!isValidId(profileId)) {
      console.warn('AppBase.getActiveRival: invalid profileId specified: %o', profileId);

      return null;
    }

    const rivalMatched = (Object.values(rivals) || []).filter(r => r.profile && (r.profile.id === profileId));

    return rivalMatched.length ? rivalMatched[0] : null;
  };

  getActiveBattlecard = () => {
    const params = getRouteParams(this.props, [
      '/profile/:profileId/battlecard/edit/:battlecardId',
      '/profile/:profileId/battlecard/edit',
      '/profile/:profileId/battlecard/embed/:battlecardId',
      '/profile/:profileId/battlecard/view/:battlecardId',
      '/profile/:profileId/battlecard/view'
    ]) || {};
    const {location: {state: locationState}} = this.props;
    const battlecardId = (locationState && locationState.battlecardId)
      ? locationState.battlecardId
      : (parseInt(params.battlecardId, 10) || 0);

    if(!Number.isInteger(battlecardId)) {
      return null;
    }
    else if(!isValidId(battlecardId, true)) {
      console.warn('AppBase.getActiveBattlecard: invalid battlecardId specified: %o', battlecardId);

      return null;
    }

    const rival = this.getActiveRival();

    if(!rival || !rival.profile || !rival.profile.battlecards) {
      return null;
    }

    const {profile: {battlecards, id, name}} = rival;
    let battlecardMatched;
    let battlecard = null;

    if(battlecardId) {
      // find requested battlecard
      battlecardMatched = battlecards.find(b => b.id === battlecardId);
    }

    if(!battlecardMatched) {
      // attempt to load default battlecard
      battlecardMatched = battlecards[0];
    }

    if(battlecardMatched) {
      battlecard = Object.assign({}, battlecardMatched, {
        profile: {id, name}
      });
    }

    return battlecard;
  };

  getCurrentLocation = (location = this.props.location) => {
    // strip trailing slash if present
    return location && location.pathname ? location.pathname.toLowerCase().replace(/\/$/, '') : '';
  };

  // enqueue a request for a user (triggers population from users API if not already loaded)
  // NOTE: default userId to null as 0 is a valid userId (current user)
  requestUser = ({userId = null, atName = ''}) => {
    return new Promise((resolve, reject) => {
      // NOTE: get userId: 0 for current user
      if((!isValidId(userId, true) && !atName)) {
        console.warn('AppBase.requestUser: invalid userId or atName specified: userId #%o, atName: %o', userId, atName);

        return reject({userId, atName});
      }

      const {users = {}} = this.state;
      let queued = false;

      if(!_.isEmpty(users)) {
        if(isValidId(userId, true) && !_.isEmpty(users[userId])) {
          console.log('AppBase.requestUser: found existing userId #%o: %o', userId, users[userId]);

          return resolve(users[userId]);
        }
        else if(atName) {
          const matchedUser = Object.values(users).filter(u => u.username === atName);

          if(!_.isEmpty(matchedUser)) {
            console.log('AppBase.requestUser: found existing atName %o: %o', atName, matchedUser);

            return resolve(matchedUser);
          }
        }
      }

      this.setState(prevState => {
        let usersState = prevState.users;

        if(_.isEmpty(usersState)) {
          usersState = {[userId]: {}};
        }
        else if(!usersState[userId]) {
          // empty user object in state indicates a pending API request
          usersState[userId] = {};
        }
        else {
          // requested user has already been queued to load
          queued = true;
        }

        return {users: usersState};
      }, async () => {
        if(!queued) {
          console.log('AppBase.requestUser: requested userId #%o, atName: %o', userId, atName);

          // queue request for user
          const user = await this.apiUserGet({userId, atName});

          return resolve(user);
        }
      });
    });
  };

  // enqueue a request for a rival (triggers population from rivals API if not already loaded)
  requestRival = ({rivalId = 0, profileId = 0, name = ''}) => {
    return new Promise((resolve, reject) => {
      if((!isValidId(rivalId) && !isValidId(profileId) && !name)) {
        console.warn('AppBase.requestRival: invalid options specified: rivalId #%o, profileId #%o, name: %o', rivalId, profileId, name);

        return reject();
      }

      const {rivals = {}} = this.state;
      let previouslyQueued = false;

      // check for previously (fully) loaded rivals
      if(!_.isEmpty(rivals)) {
        if(isValidId(rivalId) && !_.isEmpty(rivals[rivalId])) {
          console.log('AppBase.requestRival: found existing rivalId #%o: %o', rivalId, rivals[rivalId]);

          return resolve(rivals[rivalId]);
        }
        else if(isValidId(profileId) && !_.isEmpty(rivals)) {
          const matchedRival = Object.values(rivals).find(r => !_.isEmpty(r) && (r.profile.id === profileId));

          if(!_.isEmpty(matchedRival)) {
            console.log('AppBase.requestRival: found existing rival by profileId #%o: %o', profileId, matchedRival);

            return resolve(matchedRival);
          }
        }
        else if(name) {
          const matchedRival = Object.values(rivals).filter(r => r.name === name);

          if(!_.isEmpty(matchedRival)) {
            console.log('AppBase.requestRival: found existing rival name %o: %o', name, matchedRival);

            return resolve(matchedRival);
          }
        }
      }

      this.setState(prevState => {
        const {rivalsRequestQueue} = prevState;

        if(rivalId && !rivalsRequestQueue.find(r => r.rivalId === rivalId)) {
          // empty rival object in state indicates a pending API request
          rivalsRequestQueue.push({rivalId});
        }
        else if(profileId && !rivalsRequestQueue.find(r => r.profileId === profileId)) {
          rivalsRequestQueue.push({profileId});
        }
        else if(name && !rivalsRequestQueue.find(r => r.name === name)) {
          rivalsRequestQueue.push({name});
        }
        else {
          // requested rival has already been queued to load earlier
          previouslyQueued = true;
        }

        return {rivalsRequestQueue};
      }, async () => {
        if(!previouslyQueued) {
          console.log('AppBase.requestRival: requested rivalId #%o, profileId #%o, name: %o', rivalId, profileId, name);

          let rival;

          try {
            // queue request for rival
            rival = await this.apiRivalGet({rivalId, profileId, name});
          }
          catch(err) {
            // rival doesn't exist for company
            console.warn('AppBase.requestRival: unable to load requested rival');
          }

          // retrieved rival (success or failure), remove from pending request queue
          let {rivalsRequestQueue = []} = this.state;

          if(rivalId) {
            rivalsRequestQueue = rivalsRequestQueue.filter(q => q.rivalId !== rivalId);
          }
          else if(profileId) {
            rivalsRequestQueue = rivalsRequestQueue.filter(q => q.profileId !== profileId);
          }
          else if(name) {
            rivalsRequestQueue = rivalsRequestQueue.filter(q => q.name !== name);
          }

          // remove from queue, rain or shine
          this.setState({rivalsRequestQueue});

          return resolve(rival);
        }
      });
    });
  };

  requestRivals = ({rivalIds = [], profileIds = []}) => {
    return new Promise(async (resolve, reject) => {
      if(_.isEmpty(rivalIds) && _.isEmpty(profileIds)) {
        console.warn('AppBase.requestRivals: invalid options specified: rivalIds: %o, profileIds: %o', rivalIds, profileIds);

        return reject();
      }

      const rivalsToLoad = [];
      const {rivals = {}, rivalsRequestQueue = []} = this.state;
      let foundRivals = [];

      if(!_.isEmpty(rivalIds)) {
        foundRivals = !_.isEmpty(rivals) ? rivalIds.map(id => rivals[id]).filter(r => r) : [];

        if(foundRivals.length) {
          console.log('AppBase.requestRivals: found existing rivals for rivalIds: %o', foundRivals);
        }

        if(foundRivals.length < rivalIds.length) {
          rivalIds.filter(id => isValidId(id) && !foundRivals.find(r => r.id === id)).forEach(rivalId => {
            // empty rival object in state indicates a pending API request
            rivalsRequestQueue.push({rivalId});

            // NOTE: keep this separate from request queue in case other unrelated rival requests are triggered by other components
            rivalsToLoad.push({rivalId});
          });
        }
      }
      else if(!_.isEmpty(profileIds)) {
        foundRivals = Object.values(rivals || {}).filter(r => profileIds.includes(r.profile.id));

        if(foundRivals.length) {
          console.log('AppBase.requestRivals: found existing rivals for profileIds: %o', foundRivals);
        }

        if(foundRivals.length < profileIds.length) {
          profileIds.filter(id => isValidId(id) && !foundRivals.find(r => r.profile.id === id)).forEach(profileId => {
            rivalsRequestQueue.push({profileId});
            rivalsToLoad.push({profileId});
          });
        }
      }

      if(!rivalsToLoad.length) {
        // all requested rivals are already loaded
        return resolve(foundRivals);
      }

      if(!_.isEmpty(rivalIds) || !_.isEmpty(profileIds)) {
        try {
          // load requested rivals
          let rivalOptions = {};

          if(!_.isEmpty(rivalIds)) {
            rivalOptions = {rivalIds: rivalsToLoad.map(q => q.rivalId)};
          }
          else if(!_.isEmpty(profileIds)) {
            rivalOptions = {profileIds: rivalsToLoad.map(q => q.profileId)};
          }

          const {rivals: rivalsLoaded, totalRivals} = await this.apiRivalsGet(rivalOptions);

          console.log('AppBase.requestRivals: loaded %o rival%s: %o', totalRivals, (totalRivals > 1) ? 's' : '', rivalsLoaded);

          this.setState(prevState => {
            let refreshedQueue = [];

            // retrieved rivals, remove *all* from pending request queue (failed requests should no longer remain in queue)
            if(!_.isEmpty(rivalIds)) {
              refreshedQueue = prevState.rivalsRequestQueue.filter(q => !rivalIds.includes(q.rivalId));
            }
            else if(!_.isEmpty(profileIds)) {
              refreshedQueue = prevState.rivalsRequestQueue.filter(q => !profileIds.includes(q.profileId));
            }

            return {rivalsRequestQueue: refreshedQueue};
          }, () => {
            console.log('AppBase.requestRivals: updated rivalsRequestQueue: %o', this.state.rivalsRequestQueue);

            // return merged rivals listing (merging occurs in AppBase.apiRivalsGet)
            resolve(Object.values(rivalsLoaded));
          });
        }
        catch(error) {
          // rival doesn't exist for company
          console.warn('AppBase.requestRivals: unable to load requested rivalIds: %o, error: %o', rivalsToLoad, error);

          reject(error);
        }
      }
    });
  };

  getCuratorsForContainer = containerOptions => {
    if(_.isEmpty(containerOptions)) {
      console.warn('AppBase.getCuratorsForContainer: invalid options specified: %o', containerOptions);

      return;
    }

    const rivals = !_.isEmpty(this.state.rivals) ? Object.values(this.state.rivals).slice() : [];
    const {containerId, containerType} = containerOptions;
    let matchedRivals = [];
    let curators = [];

    if(containerType === 'profile') {
      matchedRivals = rivals.filter(r => r.profile && (r.profile.id === containerId));
    }
    else if(containerType === 'battlecard') {
      matchedRivals = rivals.filter(r => {
        return r.profile && r.profile.battlecards && r.profile.battlecards.filter(b => b.id === containerId).length;
      });
    }

    if(matchedRivals && matchedRivals.length) {
      curators = matchedRivals[0].profile.curators;
    }

    return curators;
  };

  // TODO: migrate remaining references to use UserUtils.getCollapsedLanes() and remove this
  getCollapsedLanes = (profileId = 0) => {
    const {currentUser: user} = this.state;

    if(_.isEmpty(user) || !isValidId(profileId)) {
      console.warn('AppBase.getCollapsedLanes: invalid options specified: user: %o, profileId: %o', user, profileId);

      return [];
    }

    const userData = user.userData || {};
    const {collapsedProfileLanes} = userData;

    if(_.isEmpty(collapsedProfileLanes)) {
      return [];
    }

    return collapsedProfileLanes[profileId] ? collapsedProfileLanes[profileId].slice() : [];
  };

  featureFlags = () => {
    const {appData = {}} = this.props;

    return (appData.user || {}).featureFlags;
  };

  // keeping it here b/c of _navigation.test.js.snap & _navigation.test.js etc? TODO: revisit.
  userIsKluebot = (user = this.state.currentUser) => {
    return userIsKluebot({userId: user.id, company: this.state.currentCompany});
  };

  userIsStaff = () => {
    const {appData = {}} = this.props;

    return appData.userCanImpersonate;
  };

  // keeping it here b/c of _navigation.test.js.snap & _navigation.test.js etc? TODO: revisit.
  userIsAdmin = roles => {
    return userIsAdmin({user: this.state.currentUser, roles});
  };

  // keeping it here, but possibly needs refactoring to point to roles_utils.userCanCurate.
  // 119 usages around the app, not doing it in this round.
  userCanCurate = roles => {
    return userCanCurate({user: this.state.currentUser, roles});
  };

  hasBattlecard = (profileId = 0) => {
    const {rivals} = this.state;

    if(!isValidId(profileId) || _.isEmpty(rivals)) {
      console.warn('AppBase.hasBattlecard: invalid profileId specified or rivals not loaded: rivalId: %o, rivals: %o', profileId, rivals);

      return null;
    }

    const rivalObjs = Object.values(rivals).slice();
    let hasBattlecard = false;

    if(rivalObjs.length) {
      const matchedProfile = rivalObjs.filter(r => r.profile && (r.profile.id === profileId));

      if(matchedProfile.length) {
        hasBattlecard = matchedProfile[0].profile.battlecardsCount > 0;
      }
    }

    return hasBattlecard;
  };

  isOnBattlecard = (battlecard = null, cardId = 0) => {
    if(battlecard === null) {
      // active battlecard may still be loading into context
      return false;
    }

    const cards = dig(battlecard, 'cards.desktop');

    // checking desktop view as (currently) cards are linked (either fully on or off) across all battlecard views
    // NOTE: cardId = 0 is legit and represents the vitals board
    if(_.isEmpty(battlecard) || !isValidId(cardId, true)) {
      console.warn('AppBase.isOnBattlecard: invalid options or no cards found: battlecard: %o, cardId: %o', battlecard, cardId);

      return false;
    }

    return cards.includes(cardId);
  };

  canAddToBattlecard = (battlecard = null) => {
    if(battlecard === null) {
      // NOTE: empty battlecard object is okay here (new/empty battlecard)
      return true;
    }

    const cards = dig(battlecard, 'cards.desktop');

    // checking desktop view as (currently) cards are linked (either fully on or off) across all battlecard views
    if(battlecard && cards) {
      // filter out blank gaps in the battlecard
      const populatedCards = cards.filter(id => parseInt(id, 10) >= 0);

      if(populatedCards.length < this._maxBattlecardCards) {
        return true;
      }

      return false;
    }

    // empty or new battlecard
    return true;
  };

  getBattlecardTemplate = (profile = null) => {
    if(_.isEmpty(profile)) {
      console.warn('AppBase.getBattlecardTemplate: invalid profile specified: %o', profile);

      return null;
    }

    const createdAt = moment().format();

    return {
      id: 0,
      title: 'Primary',       // default title for first auto-generated battlecard
      profile: {
        id: profile.id,
        name: profile.name
      },
      cards: {
        desktop: [],
        tablet: [],
        mobile: []
      },
      createdAt,
      updatedAt: createdAt
    };
  };

  getBattlecardTitle = (battlecardId = 0) => {
    const {rivals} = this.state;

    if(!isValidId(battlecardId) || _.isEmpty(rivals)) {
      console.warn(
        'AppBase.getBattlecardTitle: invalid battlecardId specified or rivals not loaded: battlecardId: %o, rivals: %o',
        battlecardId, rivals
      );

      return;
    }

    const rivalsObjs = Object.values(rivals).slice();

    // flatten array of battlecard arrays (es6 variant)
    // source: http://stackoverflow.com/a/10865042/226756
    const battlecards = [].concat(...rivalsObjs.map(r => (r.profile && r.profile.battlecards) || []));
    const matchedBattlecard = battlecards.filter(b => b.id === battlecardId);

    return matchedBattlecard.length ? matchedBattlecard[0].title : '';
  };

  enqueueToastMessage = (toastMessage = {source: '', title: '', message: '', duration: 0, isError: false, users: []}) => {
    // options format:
    //   toastMessage: {
    //     title: string,
    //     message: string,
    //     duration: int,
    //     isError: boolean,
    //     users: object[],
    //     source: string       // required, source component or module for this message (to allow for proper clearing later)
    //   }
    if(_.isEmpty(toastMessage) || !this._isMounted) {
      console.warn('AppBase.enqueueToastMessage: invalid options or component not mounted: %o, mounted: %o', toastMessage, this._isMounted);

      return;
    }

    const {toastMessages = []} = this.state;

    // assign unique identifier for message if not provided
    toastMessage.messageId = toastMessage.messageId || Math.random().toString(36).substr(2, 9);
    toastMessages.push(toastMessage);

    this.setState({toastMessages}, () => {
      console.log('AppBase.enqueueToastMessage: enqueued message: %o, toastMessages: %o', toastMessage, this.state.toastMessages);

      return toastMessage;
    });
  };

  dequeueToastMessage = (messageId = 0) => {
    const {toastMessages = []} = this.state;
    const messageIndex = toastMessages.findIndex(m => m.messageId === messageId);

    if(messageIndex >= 0) {
      toastMessages.splice(messageIndex, 1);

      this.setState({toastMessages},
        () => console.log('AppBase.dequeueToastMessage: dequeued message index: %o, toastMessages: %o', messageIndex, this.state.toastMessages));
    }
  };

  // Note: it would be good to control individual toast messages by direct references, not by array index, that can change
  clearToastMessages = (source, callback = null) => {
    const {toastMessages = []} = this.state;
    const updatesToastMessages = source
      ? toastMessages.filter(m => m.source !== source)
      : [];

    // No need to call setState if we're clearing all toast messages and none exist.
    if(!updatesToastMessages.length && !(toastMessages || []).length) {
      return typeof callback === 'function' && callback();
    }

    this.setState({toastMessages: updatesToastMessages}, () => {
      console.log('AppBase.clearToastMessages: cleared %o messages: %o', source || 'all', this.state.toastMessages);

      return typeof callback === 'function' && callback();
    });
  };

  toggleLane = ({profile = null, board = null, region = 0, delay = 0, force = null}) => {
    // NOTE: collapsed profile lane data structure:
    //   userData: {
    //     // ... pre-existing stuff ...
    //     collapsedProfileLanes: {
    //       // profileId: ['tools', 'feed', 0, ...collapsedBoardIds]
    //       // NOTE: 0 = vitals
    //       1: ['tools', 'feed', 0, 10, 20, 35, 99],
    //       99: ['tools', 'feed', 1, 23, 469, 9999],
    //       ...
    //     }
    //   };
    return new Promise((resolve, reject) => {
      const user = this.state.currentUser;

      if(_.isEmpty(user) || !profile || (!board && (region === 0))) {
        // DEBUG
        console.warn('AppBase.toggleLane: invalid options specified: profile: %o, board: %o, region: %o', profile, board, region);

        return reject();
      }

      // NOTE: below, "lane" is a generic identifier encompassing all of the potential board-like things that could be collapsed:
      // - curator tools region (if in edit mode)
      // - feed swimlane
      // - vitals swimlane (not a board)
      // - all actual boards on profile
      const userData = user.userData || {};
      const lane = region || board.id;
      const collapsedLanes = this.getCollapsedLanes(profile.id);
      const laneIndex = collapsedLanes.findIndex(l => l === lane);
      const laneStates = {
        CLOSE: 'close',
        OPEN: 'open'
      };

      if(force === null) {
        if(laneIndex >= 0) {
          // lane was collapsed, expand
          collapsedLanes.splice(laneIndex, 1);
        }
        else {
          // lane was expanded, collapsed
          collapsedLanes.push(lane);
        }
      }
      else if((force === laneStates.OPEN) && (laneIndex >= 0)) {
        // lane was collapsed, expand
        collapsedLanes.splice(laneIndex, 1);
      }
      else if((force === laneStates.CLOSE) && (laneIndex === -1)) {
        // lane was expanded, collapsed
        collapsedLanes.push(lane);
      }

      // save updated userData
      if(!_.isEmpty(userData.collapsedProfileLanes)) {
        // user had previously collapsed lanes
        userData.collapsedProfileLanes[profile.id] = collapsedLanes;
      }
      else {
        // user had no pre-existing collapsed lanes
        Object.assign(userData, {
          collapsedProfileLanes: {
            [profile.id]: collapsedLanes
          }
        });
      }

      const userUpdateAction = () => {
        const userOptions = {
          id: user.id,
          userData
        };

        this.apiUserUpdate(userOptions, updatedUser => {
          // DEBUG
          console.log('AppBase.toggleLane: %o lane #%o, updated userData: %o', (laneIndex >= 0 ? 'expanded' : 'collapsed'), lane, updatedUser.userData);

          ReactTooltip.hide();
          ReactTooltip.rebuild();

          resolve();
        });
      };

      if(delay) {
        setTimeout(userUpdateAction, delay);
      }
      else {
        userUpdateAction();
      }
    });
  };

  getNotificationCounts = () => {
    const counts = {
      staleBattlecardsCount: 0,
      commentNotificationCount: 0,
      totalNotifications: 0
    };
    const {notificationsCount: commentNotificationCount, currentUser: user, staleBattlecardsCount = 0} = this.state;

    if(!commentNotificationCount && !staleBattlecardsCount) {
      return counts;
    }

    return Object.assign(counts, {
      staleBattlecardsCount,
      commentNotificationCount,
      totalNotifications: staleBattlecardsCount + commentNotificationCount
    });
  };

  toggleJoyride = (toggle, val) => {
    // Can't lift everything into HOC b/c need access to ref/render
    this.props.joyAPI(toggle, val, this.refs.joyride);
  };

  canLoadExtension = () => ((isChrome() || isChromiumEdge()) && !isMobileBrowser());

  // company management
  loadCompany = () => {
    $.ajax({
      url: '/api/company.json',
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: company => {
        if(this._isMounted) {
          console.log('AppBase.loadCompany: loaded company %o for user %o', company, this.state.currentUser.name);

          this.handleUpdateCompany(company);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.loadCompany: error: %o, type: %o', xhr, type);
        }
      }
    });
  };

  handleUpdateCompany = company => {
    this.setState({
      currentCompany: company
    }, () => {
      console.log('AppBase.handleUpdateCompany: updated company %o for user %o', company, this.state.currentUser.name);
    });
  };

  // Company Data: load
  companyDataLoad = callback => {
    this.apiCompanyGet(companyData => {
      this.setState({
        currentCompany: companyData
      }, () => {
        typeof callback === 'function' && callback(this.state.currentCompany.companyData || {});
      });
    });
  };

  // Company Data: update
  companyDataUpdate = (companyDataToUpdate, callback) => {
    if(_.isEmpty(companyDataToUpdate)) {
      return;
    }

    const updateCompany = existingCompanyData => {
      const finalCompanyData = _.extend({}, existingCompanyData, companyDataToUpdate || {});
      const finalCompany = {
        companyData: finalCompanyData
      };

      this.apiCompanyUpdate(finalCompany, companyData => {
        this.setState({
          currentCompany: companyData
        }, () => {
          typeof callback === 'function' && callback(companyData.companyData || {});
        });
      });
    };

    // load fresh company data to reduce the chance of overwrite conflicts
    this.companyDataLoad(updateCompany);
  };

  trackRecentProfileView = profileId => {
    const user = this.state.currentUser;

    if(_.isEmpty(user) || !isValidId(profileId)) {
      return [];
    }

    const userData = user.userData || {};
    const recentlyViewedProfiles = userData.recentlyViewedProfiles ? userData.recentlyViewedProfiles.slice() : [];
    const profileIndex = recentlyViewedProfiles.findIndex(p => p === profileId);

    if(profileIndex === 0) {
      // already at correct position, so nothing to do
      return;
    }

    if(profileIndex >= 0) {
      // profile was previously visited, drop previous reference
      recentlyViewedProfiles.splice(profileIndex, 1);
    }

    // add profile as most recently viewed
    recentlyViewedProfiles.unshift(profileId);

    // save updated userData
    Object.assign(userData, {
      // trim list to last 10 items
      recentlyViewedProfiles: recentlyViewedProfiles.slice(0, 10)
    });

    const userOptions = {
      id: user.id,
      userData
    };

    this.apiUserUpdate(userOptions, updatedUser => {
      console.log('AppBase.trackRecentProfileView: viewed profileId #%o, updated userData: %o', profileId, updatedUser.userData);

      ReactTooltip.hide();
      ReactTooltip.rebuild();
    });
  };

  showAjaxTimeoutErrorMessage = toggle => {
    this.setState({
      uiShowTimeoutErrorMessage: toggle === false ? false : true
    });
  };

  _dialogComponentSetCallbacks = methods => {
    this.dialog = methods;
  };

  toggleCardOnBattlecard = (battlecard, cardId, callback) => {
    const currentRival = this.getActiveRival();

    if(!battlecard) {
      battlecard = this.getActiveBattlecard();
    }

    // if no battlecard is found, create one for the currently active rival
    if(!battlecard && currentRival) {
      const confirmMsg = '<strong>This company has no battlecards.</strong><br /><br />Would you like to create a new battlecard?';
      const battlecardOptions = {
        profileId: currentRival.profile.id
      };

      this.dialog.confirm({message: confirmMsg,
        okCallback: () => {
          this.apiBattlecardCreateOrUpdate(battlecardOptions, newBattlecard => {
            this.toggleCardOnBattlecard(newBattlecard, cardId, callback);
          });
        }
      });

      return;
    }

    let cards = battlecard.cards || {};
    let isOnBattlecard = false;

    console.log('AppBase.toggleCardOnBattlecard: toggled card %o, updated battlecard: %o', cardId ? `#${cardId}` : 'vitals', battlecard);

    // in case of missing viewport arrays (bad migration data?), refresh
    if(_.isEmpty(cards)) {
      cards = {
        desktop: [],
        tablet: [],
        mobile: []
      };
    }

    /* eslint-disable guard-for-in */
    for(const viewport in cards) {
      if(!cards.hasOwnProperty(viewport) || (cards.hasOwnProperty(viewport) && !cards[viewport])) {
        cards[viewport] = [];
      }

      if(cards[viewport].includes(cardId)) {
        const cardIndex = cards[viewport].indexOf(cardId);

        cards[viewport][cardIndex] = '';
      }
      else {
        // find first empty spot on battle card
        let firstEmptyIndex = -1;

        for(let i = 0; i < cards[viewport].length; i++) {
          if(!(parseInt(cards[viewport][i], 10) > -1)) {
            firstEmptyIndex = i;

            break;
          }
        }

        // add to empty spot or, append
        if(firstEmptyIndex > -1) {
          cards[viewport][firstEmptyIndex] = cardId;
        }
        else {
          cards[viewport].push(cardId);
        }

        isOnBattlecard = true;
      }
    }
    /* eslint-enable guard-for-in */

    const battlecardOptions = {
      id: battlecard.id,
      profileId: battlecard.profile.id,
      cardData: cards
    };

    this.apiBattlecardCreateOrUpdate(battlecardOptions, callback);

    return isOnBattlecard;
  };

  // remove the cards listed from all battlecards in this profile
  removeCardsFromBattlecards = (profile = null, cards = [], callback) => {
    const battlecards = profile ? profile.battlecards : [];

    console.log('AppBase.removeCardsFromBattlecards: profile: %o, battlecards: %o, cards to remove: %o', profile, battlecards, cards);

    if(!battlecards.length || !cards || !cards.length) {
      return;
    }

    // remove any of the following cards that are in the battlecard
    for(let i = 0; i < battlecards.length; i++) {
      const battlecard = battlecards[i];

      for(const viewport in battlecard.cards) {
        if(battlecard.cards.hasOwnProperty(viewport) && battlecard.cards[viewport]) {
          battlecard.cards[viewport] = battlecard.cards[viewport].map(cardId => {
            if(!cardId || (cards.findIndex(c => c.id === cardId) === -1)) {
              return cardId;
            }

            // replace deleted cards with null (empty, unfilled) slots
            return null;
          });
        }
      }

      this.refreshRivalBattlecard(battlecard, false, () => {
        console.log('AppBase.removeCardsFromBattlecards: refreshed profileId #%o\'s battlecard: %o, removed cards: %o', profile.id, battlecard, cards);

        return typeof callback === 'function' && callback(battlecard);
      });
    }
  };

  /*
   * API namespace (this.context.api)
   * shared api calls, accessible via context
   */

  // rivals management

  // TODO: temporary stub for api_utils.rivalsGet until we re-work rival state management
  apiRivalsGet = (rivalOptions = {page: 1, limit: RIVALS_PER_PAGE}, code = 'ApiUtils.rivalsGet') => {
    // options format:
    //   rivalOptions: {
    //     page: number,      // 1-based
    //     limit: number,     // page size
    //     order: string,     // alpha, alpha-rev, etc,
    //     recent: boolean,   // retrieves rivals matching current user's recently viewed profiles
    //     rivalIds: int[],   // array of integers, retrieve a specific set of rivals
    //     profileIds: int[], // array of integers, retrieve a specific set of profiles
    //     rivalGroupId: int, // restrict results to associated rival group id; set to 0 to retrieve all ungrouped rivals
    //     query: string      // optional, restricts results by case-insensitive search on rival name
    //   }
    return new Promise((resolve, reject) => {
      if(_.isEmpty(rivalOptions)) {
        console.warn('AppBase.apiRivalsGet: invalid options specified: %o', rivalOptions);

        return reject(rivalOptions);
      }

      rivalsGet({rivalOptions, code})
        .then(({rivals, totalRivals}) => {
          // only merge results with existing rivals if the API result is non-empty
          if(!_.isEmpty(rivals)) {
            // remap rivals array to keyed object
            rivals = rivals.reduce((map, r) => {
              map[r.id] = r;

              return map;
            }, {});

            // merge updated rivals into existing keyed object (similar to AppBase.refreshRival)
            return this.setState({
              rivals: {
                ...this.state.rivals,
                ...rivals
              },
              totalRivals
            }, () => {
              console.log('AppBase.apiRivalsGet: rivals loaded: %o', this.state.rivals);

              resolve({
                rivals: this.state.rivals,
                totalRivals: this.state.totalRivals
              });
            });
          }

          resolve({
            rivals: this.state.rivals,
            totalRivals: this.state.totalRivals
          });
        })
        .catch(error => {
          console.error('AppBase.apiRivalsGet', error);

          reject(error);
        });
    });
  };

  setContextRival = rival => this.setState({rival});

  // TODO: temporary stub for api_utils.rivalGet until we re-work state handling below (i.e. calling AppBase.refreshRival)
  apiRivalGet = (rivalOptions = {rivalId: 0, profileId: 0, name: ''}, code = 'AppBase.apiRivalGet') => {
    const {rivalId, profileId, name} = rivalOptions;

    return new Promise((resolve, reject) => {
      if(_.isEmpty(rivalOptions) || (!isValidId(rivalId) && !isValidId(profileId) && !name)) {
        console.warn('AppBase.apiRivalGet: invalid options specified: rivalOptions: %o', rivalOptions);

        return reject(rivalOptions);
      }

      rivalGet(rivalOptions, code)
        .then(async rival => {
          const refreshedRival = await this.refreshRival(rival);

          resolve(refreshedRival);
        })
        .catch(error => {
          // rivals API should already log error, so silently catch and reject here
          reject(error);
        });
    });
  };

  apiRivalCreate = ({rivalOptions, code = 'AppBase.apiRivalCreate'}) => {
    // options format:
    //    rivalOptions: {
    //      name: string,               // required
    //      url: string,                // required for company and product boards
    //      category: string,           //['other', 'company', 'product', 'industry', 'topic']
    //      withMetabaseSubscription: bool,
    //      imageUrl: string,
    //      copyFromId: string,
    //      curators: string[],
    //      rivalGroups: string[],
    //      automatedCards: string[],
    //      isTemplate: bool
    //   }
    return new Promise((resolve, reject) => {
      const {name, url, category} = rivalOptions;

      if(_.isEmpty(rivalOptions) || !name || (['company', 'product'].includes(category) && !url)) {
        console.warn('AppBase.apiRivalCreate: invalid options specified: %o', rivalOptions);

        return reject(null);
      }

      console.log(`${code}: creating new rival: %o %o`, name, url);

      post('/api/rivals.json', JSON.stringify(rivalOptions), {code})
        .then(async ({data: rival}) => {
          if(this._isMounted) {
            if(_.isEmpty(rival)) {
              console.error(`${code}: failed to create rival: %o`, rival);

              return reject(null);
            }

            // use temporary clearbit logo until rival's delayed job completes
            if(rivalOptions.iconUrl) {
              rival.iconUrl = rivalOptions.iconUrl;
            }

            const refreshedRival = await this.refreshRival(rival);

            console.log(
              `${code}: created rival successfully: %o, updated rivals: %o, totalRivals: %o`,
              rival, this.state.rivals, this.state.totalRivals
            );

            // refresh the "ungrouped companies" group so that if we're on the "all groups" dashboard view, the new rival will show up
            // NOTE: groupId = 0 is "ungrouped companies"
            const rivalGroupOptions = {rivalGroupId: 0};

            this.apiRivalGroupGet(rivalGroupOptions, code).then(rivalGroup => {
              console.log(`${code}: reloaded ungrouped rivals group: %o`, rivalGroup);

              resolve(refreshedRival);
            });
          }
        })
        .catch(error => {
          console.error(code, error);

          reject(error);
        });
    });
  };

  apiRivalDelete = ({rivalOptions = {}, code = 'AppBase.apiRivalDelete'}) => {
    // options format:
    //   rivalOptions: {
    //     id: int               // required
    //   }
    return new Promise((resolve, reject) => {
      if(_.isEmpty(rivalOptions) || !isValidId(rivalOptions.id)) {
        console.warn(`${code}: invalid options specified: %o`, rivalOptions);

        return reject(rivalOptions);
      }

      // TODO: due to the paginated load on dashboard, deletion-in-progress items will still show up until completely deleted
      // by the background worker, unless we add a "deleting" flag on the back-end to hide them from the rivals#index output
      destroy(`/api/rivals/${rivalOptions.id}.json`, {code})
        .then(({data}) => {
          if(this._isMounted) {
            console.log(`${code}: rivalId #%o queued for deletion`, rivalOptions.id);

            this.setState(prevState => ({
              rivals: ReactUpdate(prevState.rivals, {$unset: [rivalOptions.id]}),
              totalRivals: prevState.totalRivals - 1
            }), () => {
              console.log(`${code}: removed rivalId #%o, updated rivals: %o`, rivalOptions.id, this.state.rivals);

              // refresh rival groups after deleting a rival to reset placeholder counts
              this.apiRivalGroupsGet().then(() => resolve(data));
            });
          }
        })
        .catch(error => {
          console.error(code, error);

          reject(error);
        });
    });
  };

  refreshRival = (rival = {}) => {
    return new Promise((resolve, reject) => {
      if(_.isEmpty(rival) || !isValidId(rival.id)) {
        console.warn('AppBase.refreshRival: invalid rival specified: %o', rival);

        return reject(rival);
      }

      this.setState(prevState => {
        const rivalsState = {};
        let {rivals} = prevState;
        let creatingRival = false;

        if(!_.isEmpty(rivals)) {
          // adding a new rival to the collection
          if(!this.state.rivals[rival.id]) {
            creatingRival = true;
          }

          rivalsState[rival.id] = {$set: rival};

          rivals = ReactUpdate(prevState.rivals, rivalsState);
        }
        else {
          // initializing rivals object from scratch
          creatingRival = true;

          rivals = {[rival.id]: rival};
        }

        return {
          rivals,
          totalRivals: creatingRival ? prevState.totalRivals + 1 : prevState.totalRivals
        };
      }, () => {
        const refreshedRival = (this.state.rivals || {})[rival.id];

        console.log(
          'AppBase.refreshRival: rival: %o, updated rivals: %o: totalRivals: %o', refreshedRival, this.state.rivals, this.state.totalRivals
        );

        resolve(refreshedRival);
      });
    });
  };

  // TODO: no longer needed?
  refreshRivalBattlecard = (battlecard, removeBattlecard = false, callback) => {
    // find original battlecard in state and update related profile
    const rivals = !_.isEmpty(this.state.rivals) ? Object.values(this.state.rivals).slice() : [];

    if(!rivals.length || !battlecard) {
      console.warn('AppBase.refreshRivalBattlecard: invalid options specified: rivals: %o, battlecard: %o', rivals, battlecard);

      return;
    }

    const matchedRival = rivals.filter(r => r.profile && (r.profile.id === battlecard.profile.id));
    const profile = matchedRival.length ? matchedRival[0].profile : null;

    if(!profile || !profile.battlecards) {
      return;
    }

    // updating existing battlecard in state
    const battlecardIndex = profile.battlecards.findIndex(b => b.id === battlecard.id);

    if(removeBattlecard) {
      // deleted battlecard
      profile.battlecards.splice(battlecardIndex, 1);
    }
    else if(battlecardIndex >= 0) {
      // updated existing battlecard
      profile.battlecards[battlecardIndex] = battlecard;
    }
    else {
      // clear out any prior unsaved template battlecards, then add new battlecard
      profile.battlecards = profile.battlecards.filter(b => b.id > 0);
      profile.battlecards.push(battlecard);
    }

    this.refreshRivalProfile(profile).then(refreshedProfile => {
      console.log('AppBase.refreshRivalBattlecard: updated battlecard %o for profile: %o', battlecard, refreshedProfile);

      return typeof callback === 'function' && callback();
    });
  };

  refreshRivalProfile = (profile = null) => {
    return new Promise((resolve, reject) => {
      const {rivals} = this.state;

      if(_.isEmpty(rivals) || _.isEmpty(profile)) {
        console.warn('AppBase.refreshRivalProfile: invalid options specified: rivals: %o, profile: %o', rivals, profile);

        return reject({});
      }

      // refresh profile within associated rival in state
      const rival = Object.values(rivals).find(r => r.profile.id === profile.id);
      const rivalState = {};

      if(_.isEmpty(rival)) {
        return reject({});
      }

      rival.profile = profile;
      rivalState[rival.id] = {$set: rival};

      this.setState({
        rivals: ReactUpdate(this.state.rivals, rivalState)
      }, () => {
        console.log('AppBase.refreshRivalProfile: profile: %o, updated rivals: %o', profile, this.state.rivals);

        resolve(profile);
      });
    });
  };

  // rival groups management
  // groupUpdates format example: [{id: 123, action: 'add'}, {id: 321, action: 'remove'}
  refreshGroupsForRival = (rival, groupUpdates) => {
    return new Promise((resolve, reject) => {
      const {rivalGroups} = this.state;

      if(!rivalGroups || _.isEmpty(rival) || _.isEmpty(groupUpdates)) {
        console.warn('AppBase.refreshGroupsForRival: invalid options specified or groups not loaded: %o, groups: %o', {rival, groupUpdates}, rivalGroups);

        return reject();
      }

      const rivalGroupsState = rivalGroups.slice();

      groupUpdates.forEach(groupUpdate => {
        if(!groupUpdate) {
          return;
        }

        const rivalGroupIndex = rivalGroups.findIndex(g => g.id === groupUpdate.id);

        if(rivalGroupIndex >= 0) {
          const rivalGroup = Object.assign({}, rivalGroups[rivalGroupIndex]);
          const rivals = (rivalGroup.rivals || []).slice();
          const {name, id: rivalId} = rival;

          if(groupUpdate.action === 'add') {
            rivals.push({name, id: rivalId}); // only id and name are stored in rival group rivals array
          }
          else if(groupUpdate.action === 'remove') {
            const rivalIndexToRemove = rivals.map(r => r.id).indexOf(rivalId);

            if(rivalIndexToRemove > -1) {
              rivals.splice(rivalIndexToRemove, 1);
            }
          }

          rivalGroup.rivals = rivals;

          rivalGroupsState[rivalGroupIndex] = rivalGroup;
        }
      });
      this.setState({
        rivalGroups: rivalGroupsState
      }, () => resolve(rivalGroupsState));
    });
  };

  // TODO: temporary stub for api_utils.rivalGroupsGet until we re-work state handling below
  apiRivalGroupsGet = (code = 'AppBase.apiRivalGroupsGet') => {
    return new Promise((resolve, reject) => {
      rivalGroupsGet({code})
        .then(rivalGroups => {
          if(this._isMounted) {
            this.setState({rivalGroups}, () => {
              console.log(`${code}: rival groups loaded: %o`, this.state.rivalGroups);

              resolve(this.state.rivalGroups);
            });
          }
        })
        .catch(error => {
          // rivalGroups API should already log error, so silently catch and reject here
          reject(error);
        });
    });
  };

  // TODO: temporary stub for api_utils.rivalGroupGet until we re-work state handling below
  apiRivalGroupGet = (rivalGroupOptions = {rivalGroupId: 0}, code = 'AppBase.apiRivalGroupGet') => {
    const {rivalGroupId} = rivalGroupOptions;

    return new Promise((resolve, reject) => {
      // rivalGroupId = 0 is the "ungrouped companies" group
      if(_.isEmpty(rivalGroupOptions) || !isValidId(rivalGroupId, true)) {
        console.warn(`${code}: invalid options specified: rivalGroupOptions: %o`, rivalGroupOptions);

        return reject(rivalGroupOptions);
      }

      const rivalGroupIndex = (this.state.rivalGroups || []).slice().findIndex(g => g.id === rivalGroupId);

      rivalGroupGet({rivalGroupOptions, code})
        .then(rivalGroup => {
          const rivalGroupsState = {};

          rivalGroupsState[rivalGroupIndex] = {$set: rivalGroup};

          if(this._isMounted) {
            this.setState({
              rivalGroups: ReactUpdate(this.state.rivalGroups, rivalGroupsState)
            }, () => {
              console.log(`${code}: rivalGroup: %o, updated rivalGroups: %o`, rivalGroup, this.state.rivalGroups);

              resolve(rivalGroup);
            });
          }
        })
        .catch(error => {
          // rivalGroups API should already log error, so silently catch and reject here
          reject(error);
        });
    });
  };

  apiRivalGroupCreate = (rivalGroupOptions = {}, callback = null) => {
    // options format:
    //   rivalGroupOptions: {
    //     name: string,         // required
    //     rivals: [],           // optional, array of rival ids
    //   }
    if(!this.state.rivalGroups || _.isEmpty(rivalGroupOptions)) {
      console.warn('AppBase.apiRivalDelete: invalid options specified or groups not loaded: %o, groups: %o', rivalGroupOptions, this.state.rivalGroups);

      return null;
    }

    console.log('AppBase.apiRivalGroupCreate: creating new rival group %o: %o', rivalGroupOptions.name, rivalGroupOptions);

    $.ajax({
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      url: '/api/rival_groups.json',
      data: JSON.stringify(rivalGroupOptions),
      success: rivalGroup => {
        if(this._isMounted) {
          this.setState({
            rivalGroups: ReactUpdate(this.state.rivalGroups, {$push: [rivalGroup]})
          }, () => {
            console.log('AppBase.apiRivalGroupCreate: created rival group successfully: %o, updated groups: %o', rivalGroup, this.state.rivalGroups);

            return typeof callback === 'function' && callback(rivalGroup);
          });
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiRivalGroupCreate: error: %o, type: %o', xhr, type);

          if(xhr.responseJSON) {
            return typeof callback === 'function' && callback(null, xhr.responseJSON.message);
          }
        }
      }
    });
  };

  apiRivalGroupUpdate = (rivalGroupOptions = {}, callback = null) => {
    // options format:
    //   rivalGroupOptions: {
    //     id: int,              // required
    //     name: string,         // required
    //     viewOrder: float,
    //     rivals: []            // optional, array of rival ids
    //   }
    if(!this.state.rivalGroups || _.isEmpty(rivalGroupOptions)) {
      console.warn('AppBase.apiRivalGroupUpdate: invalid options specified or groups not loaded: %o, groups: %o', rivalGroupOptions, this.state.rivalGroups);

      return null;
    }

    const rivalGroups = (this.state.rivalGroups || []).slice();
    const rivalGroupIndex = rivalGroups.findIndex(g => g.id === rivalGroupOptions.id);

    // re-map add/remove rivals arrays
    if(rivalGroupOptions.rivals) {
      // get existing rival groups from state
      const rivalGroupsIds = rivalGroups[rivalGroupIndex].rivals.map(g => g.id);
      const added = rivalGroupOptions.rivals.filter(id => !rivalGroupsIds.includes(id));
      const removed = rivalGroupsIds.filter(id => !rivalGroupOptions.rivals.includes(id));

      Object.assign(rivalGroupOptions, {
        addRivals: added,          // array of rivalIds to add
        removeRivals: removed      // array of rivalIds to remove
      });

      delete rivalGroupOptions.rivals;

      console.log(
        'AppBase.apiRivalGroupUpdate: updating rival groupId #%o: %o, adding rivals: %o, removing rivals: %o',
        rivalGroupOptions.id, rivalGroupOptions, added, removed
      );
    }

    $.ajax({
      type: 'PUT',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      url: `/api/rival_groups/${rivalGroupOptions.id}.json`,
      data: JSON.stringify(rivalGroupOptions),
      success: updatedRivalGroup => {
        if(this._isMounted) {
          const rivalGroupsState = {};

          rivalGroupsState[rivalGroupIndex] = {$set: updatedRivalGroup};

          this.setState({
            rivalGroups: ReactUpdate(this.state.rivalGroups, rivalGroupsState)
          }, () => {
            console.log('AppBase.apiRivalGroupUpdate: updated rival group successfully: %o, updated groups: %o', updatedRivalGroup, this.state.rivalGroups);

            typeof callback === 'function' && callback(updatedRivalGroup);
          });
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiRivalGroupUpdate: error: %o, type: %o', xhr, type);

          if(xhr.responseJSON) {
            return typeof callback === 'function' && callback(null, xhr.responseJSON.message);
          }
        }
      }
    });
  };

  apiRivalGroupDelete = (rivalGroupOptions = {}, callback = null) => {
    // options format:
    //   rivalGroupOptions: {
    //     id: int               // required
    //   }
    if(!this.state.rivalGroups || _.isEmpty(rivalGroupOptions)) {
      console.warn('AppBase.apiRivalGroupDelete: invalid options specified or groups not loaded: %o, groups: %o', rivalGroupOptions, this.state.rivalGroups);

      return;
    }

    const rivalGroups = this.state.rivalGroups ? this.state.rivalGroups.slice() : [];
    const rivalGroupIndex = rivalGroups.findIndex(g => g.id === rivalGroupOptions.id);

    $.ajax({
      type: 'DELETE',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      url: `/api/rival_groups/${rivalGroupOptions.id}.json`,
      success: () => {
        if(this._isMounted) {
          console.log('AppBase.apiRivalGroupDelete: rival group %o deleted successfully: %o', rivalGroupOptions.name, rivalGroupOptions);

          this.setState({
            rivalGroups: ReactUpdate(this.state.rivalGroups, {
              $splice: [[rivalGroupIndex, 1]]
            })
          }, () => {
            console.log('AppBase.apiRivalGroupDelete: updated rival groups: %o', this.state.rivalGroups);

            return typeof callback === 'function' && callback();
          });
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiRivalGroupDelete: error: %o, type: %o', xhr, type);

          if(xhr.responseJSON) {
            return typeof callback === 'function' && callback(xhr.responseJSON.message);
          }
        }
      }
    });
  };

  // battlecards management
  apiBattlecardsGet = ({profileId = null, visibilityGroupId = null, stale = false, since = null, excludeUntitled = false, callback = null}) => {
    let battlecardsUrl;

    if(profileId) {
      battlecardsUrl = `/api/profiles/${profileId}/battlecards.json`;
    }
    else {
      battlecardsUrl = '/api/battlecards.json';
    }

    const params = [
      stale ? 'keep=stale' : '',
      since ? `since=${encodeURIComponent(since)}` : '',
      excludeUntitled ? `excludeUntitled=${excludeUntitled}` : '',
      visibilityGroupId ? `visibilityGroupId=${visibilityGroupId}` : ''
    ].filter(p => p).join('&');

    $.ajax({
      url: `${battlecardsUrl}${params ? `?${params}` : ''}`,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: battlecards => {
        if(this._isMounted) {
          if(profileId) {
            console.log('AppBase.apiBattlecardsGet: got battlecards for profileId #%o: %o', profileId, battlecards);
          }
          else {
            console.log(
              'AppBase.apiBattlecardsGet: got %o battlecards for company %o%o: %o',
              stale ? 'stale' : 'all', (since ? ` since ${since}` : ''), this.state.currentCompany.name, battlecards
            );
          }

          return typeof callback === 'function' && callback(battlecards);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiBattlecardsGet: error: %o, type: %o', xhr, type);
        }

        return typeof callback === 'function' && callback([]);
      }
    });
  };

  apiBattlecardCreateOrUpdate = (battlecardOptions = {}, callback = null) => {
    // options format:
    //   battlecardOptions: {
    //     id: int               // required for update action
    //     profileId: int        // required
    //     title: string         // battlecard title
    //     cardData: object      // arbitrary json data for battlecard
    //     markAsReviewed:       // true to update the reviewer and review timestamp
    //   }
    if(_.isEmpty(battlecardOptions)) {
      console.warn('AppBase.apiBattlecardCreateOrUpdate: invalid options specified: %o', battlecardOptions);

      return null;
    }

    const isUpdating = Boolean(battlecardOptions.id);
    let url;

    console.log(
      `AppBase.apiBattlecardCreateOrUpdate: ${isUpdating ? 'updating' : 'creating new'} battlecard for profileId #%o: %o`,
      battlecardOptions.profileId, battlecardOptions
    );

    if(isUpdating) {
      url = `/api/battlecards/${battlecardOptions.id}.json`;
    }
    else {
      url = `/api/profiles/${battlecardOptions.profileId}/battlecards.json`;
    }

    $.ajax({
      type: isUpdating ? 'PUT' : 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      url,
      data: JSON.stringify(battlecardOptions),
      success: battlecard => {
        if(this._isMounted) {
          console.log(
            `AppBase.apiBattlecardCreateOrUpdate: ${isUpdating ? 'updated' : 'created'} battlecard for profileId #%o successfully: %o`,
            battlecard.profile.id, battlecard
          );

          this.refreshNotificationsCount();
          this.refreshRivalBattlecard(battlecard, false, () => {
            return typeof callback === 'function' && callback(battlecard);
          });
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiBattlecardCreateOrUpdate: error: %o, type: %o', xhr, type);

          this.dialog.alert(
            `<strong>Unable to ${isUpdating ? 'update' : 'create'} battlecard</strong><br /><br />
            Sorry, we were unable to ${isUpdating ? 'update the requested' : 'create your'} battlecard.`
          );
        }
      }
    });
  };

  apiBattlecardDelete = (battlecardOptions = {}, callback = null) => {
    if(_.isEmpty(battlecardOptions) || !isValidId(battlecardOptions.id)) {
      console.warn('AppBase.apiBattlecardDelete: invalid options specified: %o', battlecardOptions);

      return;
    }

    $.ajax({
      type: 'DELETE',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      url: `/api/battlecards/${battlecardOptions.id}.json`,
      success: () => {
        if(this._isMounted) {
          console.log('AppBase.apiBattlecardDelete: battlecardId #%o deleted successfully: %o', battlecardOptions.id, battlecardOptions);

          this.refreshRivalBattlecard(battlecardOptions, true, () => {
            return typeof callback === 'function' && callback();
          });
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiBattlecardDelete: error: %o, type: %o', xhr, type);
        }
      }
    });
  };

  // TODO: temporary stub for api_utils.profileUpdate until we re-work state handling below (i.e. calling AppBase.refreshRivalProfile)
  apiProfileUpdate = (profileOptions = {}) => {
    // options format:
    //   profileOptions: {
    //     id: int,              // required
    //     wideMode: bool,
    //     isDraft: bool,
    //     curators: {
    //       add: int[],
    //       remove: int[]
    //     }
    //   }
    return new Promise((resolve, reject) => {
      if(_.isEmpty(profileOptions) || !isValidId(profileOptions.id)) {
        console.warn('AppBase.apiProfileUpdate: invalid options specified: %o', profileOptions);

        return reject();
      }

      profileUpdate({profileOptions, code: 'AppBase.apiProfileUpdate'})
        .then(async profile => {
          const refreshedProfile = await this.refreshRivalProfile(profile);

          // check if we need to refresh the current user's curator mappings
          const {curators = []} = refreshedProfile;
          const {currentUser: {id: userId}} = this.state || {currentUser: {id: 0}};

          if((curators.add && curators.add.includes(userId)) || (curators.remove && curators.remove.includes(userId))) {
            // refresh current user
            this.apiUserGet({userId});
          }

          resolve(refreshedProfile);
        })
        .catch(error => {
          // profiles API should already log error, so silently catch and reject here
          reject(error);
        });
    });
  };

  apiProfileClone = (profileOptions = {}, callback = null) => {
    // options format:
    //   profileOptions: {
    //     id: int,              // required, target profile
    //     fromId: int           // required, source profile
    //   }
    if(_.isEmpty(profileOptions) || !isValidId(profileOptions.id) || !isValidId(profileOptions.fromId)) {
      console.warn('AppBase.apiProfileClone: invalid options specified: %o', profileOptions);

      return;
    }

    $.ajax({
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(profileOptions),
      contentType: 'application/json; charset=utf-8',
      url: `/api/profiles/${profileOptions.id}.json`,
      success: clonedProfile => {
        if(this._isMounted) {
          console.log('AppBase.apiProfileClone: cloned from profileId #%o successfully: %o', profileOptions.fromId, clonedProfile);

          this.refreshRivalProfile(clonedProfile).then(refreshedProfile => {
            typeof callback === 'function' && callback(refreshedProfile);
          });
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiProfileClone: error: %o, type: %o', xhr, type);
        }
      }
    });
  };

  apiPostsGet = (postOptions = {}) => {
    // options format:
    //   postOptions: {
    //     postIds: array of prime comment IDs
    //   }
    return new Promise((resolve, reject) => {
      if(_.isEmpty(postOptions)) {
        console.warn('AppBase.apiPostsGet: invalid options specified: %o', postOptions);

        return reject(postOptions);
      }
      else if(_.isEmpty(postOptions.postIds)) {
        console.warn('AppBase.apiPostsGet: empty postIds array specified: %o', postOptions.postIds);

        return resolve([]);
      }

      // get a collection of posts, including all attachments
      // NOTE: overrides the default pagination in posts#index by requesting all items in postOptions.postIds array
      const url = '/api/posts.json';
      const params = {
        ...postOptions,
        limit: postOptions.postIds.length   // for API to retrieve all requested posts (defaults to paginated view)
      };

      fetch(url, {params, code: 'AppBase.apiPostsGet'})
        .then(({data: posts}) => {
          if(this._isMounted) {
            if(!posts || !Array.isArray(posts)) {
              console.error('AppBase.apiPostsGet: no posts found for postIds: %o', postOptions.postIds);

              return reject(postOptions);
            }

            console.log('AppBase.apiPostsGet: loaded postIds #%o: %o', postOptions.postIds, posts);

            resolve(posts);
          }
        })
        .catch(error => {
          console.error('AppBase.apiPostsGet', error);

          reject(error);
        });
    });
  };

  apiPostGet = (postId = 0, callback = null) => {
    if(!isValidId(postId)) {
      console.warn('AppBase.apiPostGet: invalid postId specified: %o', postId);

      return;
    }

    // get single post, including all attachments
    // NOTE: returned from posts#show as array with 1 post
    fetch(`/api/posts/${postId}.json`, {code: 'AppBase.apiPostGet'})
      .then(({data}) => {
        if(this._isMounted) {
          return typeof callback === 'function' && callback(data);
        }
      })
      .catch(error => {
        console.error('AppBase.apiPostGet', error);
      });
  };

  apiPostCommentsGet = (postId = 0, callback = null) => {
    if(!isValidId(postId)) {
      console.warn('AppBase.apiPostCommentsGet: invalid postId specified: %o', postId);

      return;
    }

    fetch(`/api/posts/${postId}/comments.json`, {code: 'AppBase.apiPostCommentsGet'})
      .then(({data}) => {
        if(this._isMounted) {
          return typeof callback === 'function' && callback(data);
        }
      })
      .catch(error => {
        console.error('AppBase.apiPostCommentsGet', error);
      });
  };

  /**
   * apiPostCompetitorTagUpdate - Updates post competitor tags
   *
   * @param {number} postId - Post ID
   * @param {object} competitorData - Competitor data
   * @param {Array} competitorData.deleteTags - Array of rival names to delete ({deleteTags: [rivalName]})
   * @param {Function} callback - Callback function
   * @param {Function} errorCallback - Error callback function todo Refactor callback to node style?
   */
  apiPostCompetitorTagUpdate = (postId = 0, competitorData = null, callback = null, errorCallback = null) => {
    update(`/api/posts/${postId}`, JSON.stringify(competitorData), {code: 'AppBase.apiPostCompetitorTagUpdate'})
      .then(({data}) => {
        if(this._isMounted) {
          return typeof callback === 'function' && callback(data);
        }
      })
      .catch(error => {
        console.error('AppBase.apiPostCompetitorTagUpdate', error);

        if(this._isMounted) {
          return typeof errorCallback === 'function' && errorCallback(error);
        }
      });
  };

  apiDigestsGet = ({digestOptions = {page: 1, limit: DIGESTS_PER_PAGE}, code = 'AppBase.apiDigestsGet', callback = null}) => {
    // options format:
    //   digestOptions: {
    //     page: number          // 1-indexed page number to retrieve, defaults to 1
    //     limit: number         // number of items per page, defaults to 10
    //     filter: string        // all (default), sent, draft, not_draft, manual, or not_manual
    //     typeId: number        // id of digest type being viewed
    //   }
    if(_.isEmpty(digestOptions)) {
      console.warn('AppBase.apiDigestsGet: invalid options specified: %o', digestOptions);

      return;
    }

    const {page, limit, filter, typeId} = digestOptions;
    const url = `/api/email_digests.json?page=${page}&limit=${limit}${filter ? `&filter=${filter}` : ''}${typeId ? `&typeId=${typeId}` : ''}`;

    fetch(url, code)
      .then(({data: {totalItems, items}}) => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestsGet: digests loaded: %o, total digests: %o', items, totalItems);

          return typeof callback === 'function' && callback({digests: items, totalDigests: totalItems});
        }
      });
  };

  apiDigestGet = (digestId = 0, typeId = '', callback = null) => {
    // options format:
    //   digestId: number       // required, id of digest, can be '0'/0 to refer to draft digest
    //   typeId: number         // id of digest type, used when digestId is '0'/0
    if(!isValidId(digestId, true)) {
      console.warn('AppBase.apiDigestGet: invalid digestId specified: %o', digestId);

      return;
    }

    $.ajax({
      url: `/api/email_digests/${digestId}.json${typeId ? `?typeId=${typeId}` : ''}`,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: digest => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestGet: digest loaded: %o', digest);

          return typeof callback === 'function' && callback(digest);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiDigestGet: error: %o, type: %o', xhr, type);

          return typeof callback === 'function' && callback(null);
        }
      }
    });
  };

  apiDigestPreviewGet = (digestId = 0, typeId = '', rivalGroupId) => {
    // options format:
    //   digestId: number       // required, id of digest, can be '0'/0 to refer to draft digest
    //   typeId: number         // id of digest type, used when digestId is '0'/0
    if(!isValidId(digestId, true)) {
      console.warn('AppBase.apiDigestGet: invalid digestId specified: %o', digestId);

      return;
    }

    const urlParams = serializeQueryString({typeId, rivalGroupId});
    const url = `/api/email_digests/${digestId}/preview.json${urlParams ? `?${urlParams}` : ''}`;

    return new Promise((resolve, reject) => {
      fetch(url, {code: 'AppBase.apiDigestPreviewGet'})
        .then(({data}) => {
          if(this._isMounted) {
            if(data) {
              resolve(data);
            }
          }
        })
        .catch(error => {
          console.error('AppBase.apiDigestPreviewGet', error);

          reject(error);
        });
    });
  };

  apiDigestCreate = (digestOptions = {}, callback = null) => {
    // options format:
    //   digestOptions: {
    //     title: string,
    //     summary: string,
    //     manual: boolean,       // mark as custom digest
    //     favorites: array of favorite IDs
    //     typeId: number         // id of digest type in which digest will be created
    //   }
    if(!digestOptions) {
      // create digest has no required fields, so empty digestOptions object is legit
      console.warn('AppBase.apiDigestCreate: invalid options specified: %o', digestOptions);

      return;
    }

    console.log('AppBase.apiDigestCreate: creating digest: %o', digestOptions);

    $.ajax({
      url: '/api/email_digests.json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(digestOptions),
      contentType: 'application/json; charset=utf-8',
      success: digest => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestCreate: created digest successfully: %o', digest);

          return typeof callback === 'function' && callback(digest);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiDigestCreate: error: %o, type: %o', xhr, type);

          return typeof callback === 'function' && callback(null);
        }
      }
    });
  };

  apiDigestUpdate = (digestOptions = {}, callback = null) => {
    // options format:
    //   digestOptions: {
    //     id: number            // required
    //     title: string,
    //     summary: string
    //     manual: boolean       // mark as custom digest
    //     locked: boolean       // if unlocked (default) kluebot & other curators can still modify and add/remove from this digest
    //     lastCuratorId: number // userId of last curator to edit digest
    //     sendNow: boolean,     // if true, digest is sent immediately
    //     forceNextScheduled: boolean,     // if true, next scheduled digest is always sent
    //   }
    if(_.isEmpty(digestOptions) || !isValidId(digestOptions.id)) {
      console.warn('AppBase.apiDigestUpdate: invalid options specified: %o', digestOptions);

      return;
    }

    console.log('AppBase.apiDigestUpdate: updating digest: %o', digestOptions);

    $.ajax({
      url: `/api/email_digests/${digestOptions.id}.json`,
      type: 'PUT',
      dataType: 'json',
      data: JSON.stringify(digestOptions),
      contentType: 'application/json; charset=utf-8',
      success: updatedDigest => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestUpdate: updated digest successfully: %o', updatedDigest);

          return typeof callback === 'function' && callback(updatedDigest);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiDigestUpdate: error: %o, type: %o', xhr, type);

          return typeof callback === 'function' && callback(null);
        }
      }
    });
  };

  apiDigestPreviewSend = (digestOptions = {}, callback = null) => {
    // options format:
    //   digestOptions: {
    //     id: number       // required, id of digest, can be '0'/0 to refer to draft digest
    //     typeId: number   // id of digest type, used when digestId is '0'/0
    //   }
    const {id: digestId} = digestOptions;

    if(_.isEmpty(digestOptions) || !isValidId(digestId, true)) {
      console.warn('AppBase.apiDigestUpdate: invalid options specified: %o', digestOptions);

      return;
    }

    console.log('AppBase.apiDigestUpdate: updating digest: %o', digestOptions);

    $.ajax({
      url: `/api/email_digests/${digestId}/send_preview`,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(digestOptions),
      contentType: 'application/json; charset=utf-8',
      success: () => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestPreviewSend: Sent preview digest succesfully: %o', null);

          return typeof callback === 'function' && callback();
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiDigestPreviewSend: error: %o, type: %o', xhr, type);

          return typeof callback === 'function' && callback({error: 'unable send preview'});
        }
      }
    });
  };

  apiDigestDelete = (digestOptions = {}, callback = null) => {
    // options format:
    //   digestOptions: {
    //     id: number              // required
    //   }
    if(_.isEmpty(digestOptions) || !isValidId(digestOptions.id)) {
      console.warn('AppBase.apiDigestDelete: invalid options specified: %o', digestOptions);

      return;
    }

    console.warn('AppBase.apiDigestDelete: deleting digestId #%o', digestOptions.id);

    $.ajax({
      url: `/api/email_digests/${digestOptions.id}.json`,
      type: 'DELETE',
      dataType: 'json',
      data: JSON.stringify(digestOptions),
      contentType: 'application/json; charset=utf-8',
      success: message => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestDelete: success: deleted digest: %o', message);

          return typeof callback === 'function' && callback();
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiDigestDelete: error: %o, type: %o', xhr, type);

          if(xhr.responseJSON) {
            return typeof callback === 'function' && callback(null, xhr.responseJSON.message);
          }
        }
      }
    });
  };

  apiFavoritesGet = (callback = null) => {
    $.ajax({
      url: '/api/favorites.json',
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: favorites => {
        if(this._isMounted) {
          console.log('AppBase.apiFavoritesGet: favorites loaded: %o', favorites);

          return typeof callback === 'function' && callback(favorites);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiFavoritesGet: error: %o, type: %o', xhr, type);

          return typeof callback === 'function' && callback(null);
        }
      }
    });
  };

  apiDigestFavoritesGet = (digestId, callback = null) => {
    $.ajax({
      url: `/api/favorites.json${digestId ? `?emailDigestId=${digestId}` : ''}`,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: favorites => {
        if(this._isMounted) {
          console.log('AppBase.apiFavoritesGet: favorites loaded: %o', favorites);

          return typeof callback === 'function' && callback(favorites);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiFavoritesGet: error: %o, type: %o', xhr, type);

          return typeof callback === 'function' && callback(null);
        }
      }
    });
  };

  apiFavoritesUpdateBatch = (favorites = [], callback = null) => {
    // NOTE: assumes all batched favorites are part of the same emailDigestId
    if(_.isEmpty(favorites)) {
      console.warn('AppBase.apiFavoritesUpdateBatch: invalid favorites specified: %o', favorites);

      return;
    }

    const requests = favorites.filter(f => Boolean(f.emailDigestId)).map(f => {
      return new Promise(resolve => {
        this.apiFavoriteUpdate(f, true, resolve);
      });
    });

    Promise.all(requests).then(() => {
      console.log('AppBase.apiFavoriteUpdateBatch: batch updated favorites successfully: %o', favorites);

      return typeof callback === 'function' && callback(favorites);
    });
  };

  apiFavoriteCreate = async (favoriteOptions = {}, callback = null) => {
    // options format:
    //   favoriteOptions: {
    //     postId: int,          // required
    //     emailDigestId: int,   // required
    //     curatedTitle: string,
    //     curatedCommentary: string,
    //     curatedSummary: string,
    //     viewOrder: float
    //   }
    if(_.isEmpty(favoriteOptions) || !isValidId(favoriteOptions.postId) || !isValidId(favoriteOptions.emailDigestId)) {
      console.warn('AppBase.apiFavoriteCreate: invalid options specified: %o', favoriteOptions);

      return;
    }

    console.log('AppBase.apiFavoriteCreate: creating favorite with postId #%o: %o', favoriteOptions.postId, favoriteOptions);

    try {
      const res = await post(
        `/api/posts/${favoriteOptions.postId}/favorite.json`,
        JSON.stringify(favoriteOptions),
        {
          headers: {
            'Content-Type': 'application/json; charset=utf-8'
          }
        }
      );

      if(this._isMounted) {
        console.log('AppBase.apiFavoriteCreate: favorite with postId #%o created: %o', favoriteOptions.postId, res.data);

        return typeof callback === 'function' && callback(res.data);
      }
    }
    catch(err) {
      let error = err;

      console.error(err);

      if(this._isMounted) {
        console.error('AppBase.apiFavoriteCreate: error: %o', err);

        if(err.response) {
          error = err.response.message;
        }
      }

      return typeof callback === 'function' && callback(null, error);
    }
  };

  apiFavoriteUpdate = async (favoriteOptions = {}, isBatched = false, callback = null) => {
    // options format:
    //   favoriteOptions: {
    //     id: int,              // required
    //     emailDigestId: int,
    //     curatedTitle: string,
    //     curatedCommentary: string,
    //     curatedSummary: string,
    //     viewOrder: float
    //   }
    if(_.isEmpty(favoriteOptions) || !isValidId(favoriteOptions.id)) {
      console.warn('AppBase.apiFavoriteUpdate: invalid options specified: %o', favoriteOptions);

      return;
    }

    console.log('AppBase.apiFavoriteUpdate: updating favoriteId #%o: %o', favoriteOptions.id, favoriteOptions);

    try {
      const res = await update(
        `/api/favorites/${favoriteOptions.id}.json`,
        JSON.stringify(favoriteOptions),
        {
          headers: {
            'Content-Type': 'application/json; charset=utf-8'
          }
        }
      );

      if(this._isMounted) {
        if(!isBatched) {
          console.log('AppBase.apiFavoriteUpdate: favoriteId #%o updated: %o', res.data.id, res.data);
        }
        else {
          console.log('AppBase.apiFavoriteUpdate: batched favoriteId #%o updated: %o', res.data.id, res.data);
        }

        return typeof callback === 'function' && callback(res.data);
      }
    }
    catch(err) {
      let error = err;

      console.error(err);

      if(this._isMounted) {
        console.error('AppBase.apiFavoriteUpdate: error: %o', err);

        if(err.response) {
          error = err.response.message;
        }

        return typeof callback === 'function' && callback(null, error);
      }
    }
  };

  apiFavoriteDelete = async (favoriteOptions = {}, callback = null) => {
    // options format:
    //   favoriteOptions: {
    //     postId: int,          // required
    //     emailDigestId: int
    //   }
    if(_.isEmpty(favoriteOptions) || !isValidId(favoriteOptions.postId)) {
      console.warn('AppBase.apiFavoriteDelete: invalid options specified: %o', favoriteOptions);

      return;
    }

    console.log('AppBase.apiFavoriteDelete: deleting favoriteId #%o: %o', favoriteOptions.postId, favoriteOptions);

    try {
      const res = await post(
        `/api/posts/${favoriteOptions.postId}/unfavorite`,
        JSON.stringify(favoriteOptions),
        {
          headers: {
            'Content-Type': 'application/json; charset=utf-8'
          }
        }
      );

      if(this._isMounted) {
        console.log('AppBase.apiFavoriteDelete: favorite #%o deleted: %o', favoriteOptions.postId, res.data);

        return typeof callback === 'function' && callback(res.data);
      }
    }
    catch(err) {
      let error = err;

      console.error(err);

      if(this._isMounted) {
        console.error('AppBase.apiFavoriteDelete: error: %o', err);

        if(err.response) {
          error = err.response.message;
        }
      }

      return typeof callback === 'function' && callback(null, error);
    }
  };

  // user management
  apiUsersGet = (userOptions = {kluebot: false, fallback: false, deleted: false, typeFilter: ''}, callback = null) => {
    // options format:
    //   userOptions: {
    //     kluebot: bool,
    //     fallback: bool,
    //     deleted: bool,
    //     full: non-null,
    //     typeFilter: string
    //   }
    if(_.isEmpty(userOptions)) {
      console.warn('AppBase.apiUsersGet: invalid options specified: %o', userOptions);

      return;
    }

    console.log('AppBase.apiUsersGet: loading users: options: %o', userOptions);

    const {full, typeFilter, ...keepOptions} = {...userOptions, deleted: this.userCanCurate()};
    const keep = Object.keys(keepOptions).reduce((acc, key) => {
      if(userOptions[key]) {
        acc.push(key);
      }

      return acc;
    }, []);

    const urlParams = serializeQueryString({
      keep: keep.join(','),
      full,
      typeFilter
    });

    $.ajax({
      url: `/api/users.json${urlParams ? `?${urlParams}` : ''}`,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: users => {
        if(this._isMounted) {
          // remap users array to object + add name, prettyName & image variants on client-side
          users = users.reduce((map, u) => {
            map[u.id] = mergeExtendedUserProperties(u);

            return map;
          }, {});

          this.setState({users}, () => {
            console.log(
              'AppBase.apiUsersGet: loaded %s users for company %o: %o',
              (full ? 'full' : 'base'), this.state.currentCompany.name, this.state.users
            );

            typeof callback === 'function' && callback(this.state.users);
          });
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiUsersGet: error: %o, type: %o', xhr, type);

          if(type === 'timeout') {
            this.showAjaxTimeoutErrorMessage();
          }
        }
      }
    });
  };

  // TODO: temporary stub for api_utils.userGet until we re-work state handling below (i.e. calling AppBase.refreshUser)
  apiUserGet = async (userOptions = {userId: 0, atName: ''}, code = 'AppBase.apiUserGet') => {
    const {userId, atName} = userOptions;

    return new Promise((resolve, reject) => {
      // NOTE: get userId: 0 for current user
      if(_.isEmpty(userOptions) || (!isValidId(userId, true) && !atName)) {
        console.warn('AppBase.apiUserGet: invalid userId or atName specified: userId #%o, atName: %o', userId, atName);

        return reject(userOptions);
      }

      userGet(userOptions, code)
        .then(async user => {
          // refresh updated user in users collection
          const refreshedUser = await this.refreshUser(user);

          resolve(refreshedUser);
        })
        .catch(error => {
          console.error('AppBase.apiUserGet', error);

          reject(error);
        });
    });
  };

  apiUserUpdate = (userOptions = {}, code = 'apiUserUpdate') => {
    return new Promise((resolve, reject) => {
      userUpdate({userOptions})
        .then(async updatedUser => {
          // refresh updated user in users collection
          const refreshedUser = await this.refreshUser(updatedUser);

          console.log('AppBase.apiUserUpdate: updated user: %o', refreshedUser);

          resolve(refreshedUser);
        })
        .catch(error => {
          console.error(code, error);

          reject(error);
        });
    });
  };

  apiUserDelete = (userOptions = {}, callback = null) => {
    // options format:
    //   userOptions: {
    //     id: int,              // required
    //     undo: string
    //   }
    if(!userOptions || !isValidId(userOptions.id)) {
      console.warn('AppBase.apiUserDelete: invalid options specified: %o', userOptions);

      return;
    }

    console.log('AppBase.apiUserDelete: %o user: %o', userOptions.undo ? 're-activating' : 'deactivating', userOptions);

    $.ajax({
      url: `/api/users/${userOptions.id}.json`,
      type: 'DELETE',
      dataType: 'json',
      data: JSON.stringify(userOptions),
      contentType: 'application/json; charset=utf-8',
      success: updatedUser => {
        if(this._isMounted) {
          console.log('AppBase.apiUserDelete: success: updated user: %o', updatedUser);

          // refresh updated user in users collection
          this.refreshUser(updatedUser).then(refreshedUser => {
            return typeof callback === 'function' && callback(refreshedUser);
          });
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiUserDelete: error: %o, type: %o', xhr, type);

          if(xhr.responseJSON) {
            return typeof callback === 'function' && callback(null, xhr.responseJSON.message);
          }
        }
      }
    });
  };

  apiUserReconfirm = (userOptions = {}, callback = null) => {
    // options format:
    //   user: {
    //     id: int,              // required
    //     name: string,         // required
    //     email: string         // required
    //   }
    if(_.isEmpty(userOptions) || !isValidId(userOptions.id)) {
      console.warn('AppBase.apiUserReconfirm: invalid options specified: %o', userOptions);

      return;
    }

    $.ajax({
      url: `/api/users/${userOptions.id}/reconfirm.json`,
      type: 'PUT',
      dataType: 'json',
      data: JSON.stringify(userOptions),
      contentType: 'application/json; charset=utf-8',
      success: message => {
        if(this._isMounted) {
          console.log('AppBase.apiUserReconfirm: re-confirmation message sent to user: %o, message: %o', userOptions, message);

          this.enqueueToastMessage({
            title: 'Confirmation Sent',
            message: `Confirmation email successfully sent to ${userOptions.name} (${userOptions.email}).`,
            duration: 5000,
            source: 'AppBase'
          });

          return typeof callback === 'function' && callback();
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiUserReconfirm: error: %o, type: %o', xhr, type);

          if(xhr.responseJSON) {
            return typeof callback === 'function' && callback(null, xhr.responseJSON.message);
          }
        }
      }
    });
  };

  refreshUser = (user = {}) => {
    return new Promise((resolve, reject) => {
      if(_.isEmpty(user) || !isValidId(user.id)) {
        console.warn('AppBase.refreshUser: invalid user specified: %o', user);

        return reject(user);
      }

      const {currentUser} = this.state;

      user = mergeExtendedUserProperties(user);

      console.log('AppBase.refreshUser: refreshing user: %o', user);

      if(user.id === currentUser.id) {
        // update only existing properties of currently logged in user
        for(const prop in user) {
          if(currentUser.hasOwnProperty(prop)) {
            currentUser[prop] = user[prop];
          }
        }

        this.setState({
          currentUser: mergeExtendedUserProperties(currentUser)
        }, () => console.log('AppBase.refreshUser: current user refreshed: %o', this.state.currentUser));
      }

      this.setState(prevState => {
        const usersState = {};
        let {users} = prevState;

        if(!_.isEmpty(users)) {
          usersState[user.id] = {$set: user};

          users = ReactUpdate(prevState.users, usersState);
        }
        else {
          users = {[user.id]: user};
        }

        return {users};
      }, () => {
        const refreshedUser = this.state.users[user.id];

        console.log('AppBase.refreshUser: user: %o, updated users: %o', refreshedUser, this.state.users);

        resolve(refreshedUser);
      });
    });
  };

  // company management
  apiCompanyGet = (callback = null) => {
    $.ajax({
      url: '/api/company.json',
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: company => {
        if(this._isMounted) {
          console.log('AppBase.apiCompanyGet: loaded company: %o', company);

          // refresh current company
          this.refreshCompany(company, callback);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiCompanyGet: error: %o, type: %o', xhr, type);
        }
      }
    });
  };

  apiDigestTypesGet = ({digestTypeOptions = {}, code = 'AppBase.apiDigestTypesGet', callback = null}) => {
    // options format:
    //   digestTypeOptions: {
    //   }
    const url = '/api/email_digest_types.json';

    fetch(url, code)
      .then(data => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestTypesGet: email_digest_types loaded: %o', data);

          return typeof callback === 'function' && callback(data);
        }
      });
  };

  apiDigestTypeGet = (digestTypeId = 0, callback = null) => {
    if(!isValidId(digestTypeId, true)) {
      console.warn('AppBase.apiDigestTypeGet: invalid digestTypeId specified: %o', digestTypeId);

      return;
    }

    $.ajax({
      url: `/api/email_digest_types/${digestTypeId}.json`,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: digestType => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestTypeGet: digestType loaded: %o', digestType);

          return typeof callback === 'function' && callback(digestType);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiDigestTypeGet: error: %o, type: %o', xhr, type);

          return typeof callback === 'function' && callback(null);
        }
      }
    });
  };

  apiDigestTypeCreate = (digestTypeOptions = {}, callback = null) => {
    // options format:
    //   digestTypeOptions: {
    //     name: string,                // required: name for digest type
    //     default: boolean,            // optional: set digest type as the default for company
    //     reviewBannerUrl: string,     // optional: default banner image url for digests created in future
    //     reviewRole: string,          // optional: one of 'admin', 'curator', or null for all users
    //     reviewFrequency: string,     // optional: enum: one of 'daily', 'weekly', 'biweekly', 'monthly', 'once', 'never'
    //     reviewDay: string,           // optional: enum: one of 'monday', 'tuesday', ..., 'sunday'
    //     reviewHour: number,          // optional: enum: one of 0 .. 23
    //     reviewItemsPerRival: string  // optional: number, 1-10
    //     reviewSendOnceAt: string,    // optional: future send time in iso8601 time format; only relevant when reviewFrequency is 'once'
    //   }
    if(_.isEmpty(digestTypeOptions)) {
      console.warn('AppBase.apiDigestTypeCreate: invalid options specified: %o', digestTypeOptions);

      return;
    }

    console.log('AppBase.apiDigestTypeCreate: creating digest: %o', digestTypeOptions);

    $.ajax({
      url: '/api/email_digest_types.json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(digestTypeOptions),
      contentType: 'application/json; charset=utf-8',
      success: digestType => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestTypeCreate: created digestType successfully: %o', digestType);

          return typeof callback === 'function' && callback(digestType);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiDigestTypeCreate: error: %o, type: %o', xhr, type);

          return typeof callback === 'function' && callback(null);
        }
      }
    });
  };

  apiDigestTypeUpdate = (digestTypeOptions = {}, callback = null) => {
    // options format:
    //   digestTypeOptions: {
    //     id: integer,                 // required: id
    //     name: string,                // optional
    //     default: boolean,            // optional: set digest type as the default for company
    //     reviewBannerUrl: string,     // optional: default banner image url for digests created in future
    //     reviewRole: string,          // optional: one of 'admin', 'curator', or null for all users
    //     reviewFrequency: string,     // optional: enum: one of 'daily', 'weekly', 'biweekly', 'monthly', 'once', 'never'
    //     reviewDay: string,           // optional: enum: one of 'monday', 'tuesday', ..., 'sunday'
    //     reviewHour: number,          // optional: enum: one of 0 .. 23
    //     reviewItemsPerRival: string  // optional: number, 1-10
    //     reviewSendOnceAt: string,    // optional: future send time in iso8601 time format; only relevant when reviewFrequency is 'once'
    //   }
    if(_.isEmpty(digestTypeOptions) || !isValidId(digestTypeOptions.id)) {
      console.warn('AppBase.apiDigestTypeUpdate: invalid options specified: %o', digestTypeOptions);

      return;
    }

    $.ajax({
      type: 'PUT',
      url: `/api/email_digest_types/${digestTypeOptions.id}.json`,
      data: JSON.stringify(digestTypeOptions),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: updatedDigestType => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestTypeUpdate: updated digestType: %o', updatedDigestType);

          // update currentCompany with changes if defaultDigestType.id === updatedDigestType.id
          const {currentCompany} = this.state;

          if(updatedDigestType.id === currentCompany?.defaultDigestType?.id) {
            this.setState({
              currentCompany: {...currentCompany, defaultDigestType: updatedDigestType}
            }, () => {
              const {currentCompany: updatedCompany} = this.state;

              console.log('AppBase.apiDigestTypeUpdate: current company digestType refreshed: %o', updatedCompany);
            });
          }

          return typeof callback === 'function' && callback(updatedDigestType);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiCompanyUpdate: error: %o, type: %o', xhr, type);

          return typeof callback === 'function' && callback(null, xhr, type);
        }
      }
    });
  };

  apiDigestTypeDelete = (digestTypeOptions = {}, callback = null) => {
    // options format:
    //   digestTypeOptions: {
    //     id: int
    //   }
    if(_.isEmpty(digestTypeOptions) || !isValidId(digestTypeOptions.id)) {
      console.warn('AppBase.apiDigestTypeDelete: invalid options specified: %o', digestTypeOptions);

      return;
    }

    console.warn('AppBase.apiDigestTypeDelete: deleting digestTypeId #%o', digestTypeOptions.id);

    $.ajax({
      url: `/api/email_digest_types/${digestTypeOptions.id}.json`,
      type: 'DELETE',
      dataType: 'json',
      data: JSON.stringify(digestTypeOptions),
      contentType: 'application/json; charset=utf-8',
      success: message => {
        if(this._isMounted) {
          console.log('AppBase.apiDigestTypeDelete: success: deleted digestType: %o', message);

          return typeof callback === 'function' && callback(true);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiDigestTypeDelete: error: %o, type: %o', xhr, type);

          if(xhr.responseJSON) {
            return typeof callback === 'function' && callback(false, xhr.responseJSON.message);
          }

          return typeof callback === 'function' && callback(false);
        }
      }
    });
  };

  apiCompanyUpdate = (companyOptions = {}, callback = null) => {
    // options format:
    //   companyOptions: {
    //     name: string,
    //     url: string,
    //     description: string,
    //     DUNSNumber: string,
    //     facebookUsername: string,
    //     twitterUsername: string,
    //     linkedinUsername: string,
    //     googleUsername: string,
    //     companyData: object,
    //     reviewStyle: number,         // enum: 0, 1
    //     addEmailDomains: string[],
    //     removeEmailDomains: string[]
    //   }
    if(_.isEmpty(companyOptions)) {
      console.warn('AppBase.apiCompanyUpdate: invalid options specified: %o', companyOptions);

      return;
    }

    $.ajax({
      type: 'PUT',
      url: '/api/company.json',
      data: JSON.stringify(companyOptions),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: updatedCompany => {
        if(this._isMounted) {
          console.log('AppBase.apiCompanyUpdate: updated company: %o', updatedCompany);

          // refresh current company
          this.refreshCompany(updatedCompany, callback);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiCompanyUpdate: error: %o, type: %o', xhr, type);
        }
      }
    });
  };

  refreshCompany = (company = {}, callback = null) => {
    if(_.isEmpty(company)) {
      console.warn('AppBase.refreshCompany: invalid company specified: %o', company);
    }

    const {currentCompany} = this.state;

    console.log('AppBase.refreshCompany: refreshing company: %o', company);

    if(company.id === currentCompany.id) {
      // update only existing properties of current company
      for(const prop in company) {
        if(currentCompany.hasOwnProperty(prop)) {
          currentCompany[prop] = company[prop];
        }
      }

      this.setState({
        currentCompany
      }, () => {
        console.log('AppBase.refreshCompany: current company refreshed: %o', this.state.currentCompany);

        return typeof callback === 'function' && callback(this.state.currentCompany);
      });
    }
    else {
      return typeof callback === 'function' && callback(currentCompany);
    }
  };

  // metabase queries management
  apiMetabaseQueriesGet = (rivalId, callback = null) => {
    let url;

    if(rivalId === 0) {
      url = '/api/metabase_subscriptions.json';
    }
    else if(!isValidId(rivalId)) {
      return;
    }
    else {
      url = `/api/rival/${rivalId}/metabase_subscriptions.json`;
    }

    $.ajax({
      url,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: data => {
        if(this._isMounted) {
          return typeof callback === 'function' && callback(data || []);
        }
      },
      error: (xhr, type) => {
        if(this._isMounted) {
          console.error('AppBase.apiMetabaseQueriesGet: error: %o, type: %o', xhr, type);

          if(type === 'timeout') {
            this.showAjaxTimeoutErrorMessage();
          }
          else if(xhr.status && (xhr.status === 401 || xhr.status === 422)) {
            // logged out error code
            this.dialog.alert(
              'Your login session has expired',
              () => window.location.reload(),
              'Login again'
            );
          }
        }
      }
    });
  };

  apiSearch = (url, callback) => {
    fetch(url, {code: 'AppBase.apiSearch'})
      .then(data => typeof callback === 'function' && callback(data.data));
  };

  apiMonitorsGet = (params, callback) => {
    fetch('/api/monitors.json', {
      code: 'AppBase.apiMonitorsGet',
      params
    })
      .then(({data}) => {
        if(this._isMounted) {
          return typeof callback === 'function' && callback(data);
        }
      });
  };

  apiMonitorGet = (id, params, callback) => {
    fetch(`/api/monitor/${id}/highlight_contents.json`, {
      code: 'AppBase.apiMonitorGet',
      params
    })
      .then(({data}) => {
        if(this._isMounted) {
          return typeof callback === 'function' && callback(data);
        }
      });
  };

  apiMonitorContentsGet = (id, callback) => {
    fetch(`/api/highlight_contents/${id}.json`, {
      code: 'AppBase.apiMonitorContentsGet'
    })
      .then(({data}) => {
        if(this._isMounted) {
          return typeof callback === 'function' && callback(data);
        }
      });
  };

  apiMonitorDelete = (id, callback) => {
    destroy(`/api/monitor/${id}`, {
      code: 'AppBase.apiMonitorDelete',
      params: {clearHistory: true}
    })
      .then(({data}) => {
        if(this._isMounted) {
          return typeof callback === 'function' && callback(data);
        }
      });
  };

  isEmbedHtmlDynamicCardsEnabled = () => {
    // per company boolean flag is stored in company_data['embedHtmlDynamicCardsEnabled']
    const flags = this.featureFlags();

    return flags && flags.embedHtmlDynamicCardsEnabled;
  };

  apiVisibilityGroupsGet = ({code = 'AppBase.apiVisibilityGroupsGet'}) => {
    return new Promise((resolve, reject) => {
      fetch('/api/visibility_groups.json', {code})
        .then(({data}) => {
          if(this._isMounted) {
            const visibilityGroups = data || [];

            this.setState({visibilityGroups}, () => resolve(data));
          }
        })
        .catch(error => {
          console.error('AppBase.apiVisibilityGroupsGet', error);

          reject(error);
        });
    });
  };

  apiVisibilityGroupCreate = ({code = 'AppBase.apiVisibilityGroupCreate', visibilityGroupOptions}) => {
    // options format:
    //   visibilityGroupOptions: {
    //    name:               required, the display value of the visibility group
    //    viewOrder:          optional, view order
    //    isUserDefault:      optional, whether group is a user default group (new users will belong to this automatically)
    //    isCardDefault:      optional, whether group is a card default group (new cards will belong to this automatically)
    //   }
    this.setState({
      visibilityGroups: [...this.state.visibilityGroups, visibilityGroupOptions]
    });

    return new Promise((resolve, reject) => {
      post('/api/visibility_groups.json', JSON.stringify(visibilityGroupOptions), {code})
        .then(({data}) => {
          if(this._isMounted) {
            const updatedGroup = data || {};

            this.setState({
              visibilityGroups: this.state.visibilityGroups.map(g => {
                if(!g.id) {
                  return updatedGroup;
                }

                return g;
              })
            }, () => resolve(updatedGroup));
          }
        })
        .catch(error => {
          console.error('AppBase.apiVisibilityGroupCreate', error);

          reject(error);
        });
    });
  };

  apiVisibilityGroupUpdate = ({code = 'AppBase.apiVisibilityGroupUpdate', visibilityGroupOptions}) => {
    // options format:
    //   visibilityGroupOptions: {
    //     id: number,             required
    //     name: string,           required
    //     viewOrder: string       optional
    //     isUserDefault: bool     optional, whether groups is a user default group (new users will belong to this automatically)
    //     isCardDefault: bool     optional, whether groups is a card default group (new cards will belong to this automatically)
    //   }
    this.setState({
      visibilityGroups: this.state.visibilityGroups.map(g => {
        if(g.id === visibilityGroupOptions.id) {
          return visibilityGroupOptions;
        }

        return g;
      })
    });

    return new Promise((resolve, reject) => {
      update(`/api/visibility_groups/${visibilityGroupOptions.id}.json`, visibilityGroupOptions, {code})
        .then(({data}) => {
          if(this._isMounted) {
            const updatedGroup = data || {};

            this.setState({
              visibilityGroups: this.state.visibilityGroups.map(g => {
                if(g.id === updatedGroup.id) {
                  return updatedGroup;
                }

                return g;
              })
            }, () => resolve(updatedGroup));
          }
        })
        .catch(error => {
          console.error('AppBase.apiVisibilityGroupUpdate', error);

          reject(error);
        });
    });
  };

  apiVisibilityGroupDelete = ({code = 'AppBase.apiVisibilityGroupDelete', visibilityGroupOptions}) => {
    // options format:
    //   visibilityGroupOptions: {
    //     id: number         // required
    //   }
    this.setState({
      visibilityGroups: this.state.visibilityGroups.filter(g => g.id !== visibilityGroupOptions.id)
    });

    return new Promise((resolve, reject) => {
      destroy(`/api/visibility_groups/${visibilityGroupOptions.id}.json`, {code})
        .then(({data}) => {
          if(this._isMounted) {
            resolve(data || {});
          }
        })
        .catch(error => {
          console.error('AppBase.apiVisibilityGroupDelete', error);

          reject(error);
        });
    });
  };

  displayMobileDownloadBanner = () => isAndroidOriOSBrowser() && !getMobileBannerDismissedFromLS();

  isAssignVisibilityGroupViaSSOFeatureEnabled = () => {
    // per company boolean flag is stored in company_data['assignVisibilityGroupViaSSO']
    const flags = this.featureFlags();

    return flags && flags.assignVisibilityGroupViaSSO;
  };

  isCardTagVisible = () => {
    const isCurator = this.userCanCurate();
    const isConsumerVisible = Boolean(this.featureFlags()?.cardTagIsConsumerVisible);

    return isCurator || isConsumerVisible;
  };

  suppressionNotificationDisabled = () => {
    return Boolean(this.featureFlags()?.suppressionNotificationDisabled || false);
  };

  printBattlecardDisabled = () => {
    return Boolean(this.featureFlags()?.printBattlecardDisabled || false);
  };

  automatedDataFeedbackReportingDisabled = () => !this.userCanCurate() || Boolean(this.featureFlags()?.automatedDataFeedbackReportingDisabled);

  isCardEditorLinkSelectorDisabled = () => Boolean(this.featureFlags()?.cardEditorLinkSelectorDisabled);

  isDisableDigestPreviewSend = () => Boolean(this.featureFlags()?.disableDigestPreviewSend);

  isDigestMultiplesEnabled = () => Boolean(this.featureFlags()?.digestMultiplesEnabled);

  // dashboard - if display options change (i.e. sort, group selection)
  handleDashboardDisplayChange = () => new Promise(resolve => {
    this.setState({
      rivals: null,
      totalRivals: 0
    }, () => resolve(this.state.rivals));
  });

  // comment modal
  handleCloseProfileCommentClick = callback => {
    this.dialog.remove('profile-comment-modal');

    typeof callback === 'function' && callback();
  };

  handleCreateProfileCommentClick = (containerId, containerType) => this.renderProfileCommentModal(containerId, containerType);

  handleNotificationsClick = event => {
    this._preventDefault(event);

    this.handleCloseProfileCommentClick(() => {
      this.props.history.push('/notifications');
    });
  };

  handleCuratorClick = (curatorId, event) => {
    this._preventDefault(event);

    this.handleCloseProfileCommentClick();

    this.props.history.push(`/users/${curatorId}`);
  };

  // this.dialog... would become this.utils.dialog... on child context components
  // changing state won't update modal automatically; run 'this.renderProfileCommentModal' after updating state
  /* e.g.:
    this.setState({
      newVal: true
    }, () => {
      this.renderProfileCommentModal();
    });
  */
  renderProfileCommentModal = (containerId, containerType) => {
    if(!containerId || !containerType) {
      return;
    }

    const {currentUser, users} = this.state;
    const profileCurators = this.getCuratorsForContainer({
      containerId,
      containerType
    });
    let curatorsMessage;
    let commentMessage;
    let isCurator = false;
    let isProfileCurator = false;

    if(Object.keys(users || {}).length) {
      if(profileCurators.length) {
        const curatorUsers = sortUsers({users: profileCurators.map(curatorId => users[curatorId]), userToShowFirst: currentUser});
        let curatorLinks = curatorUsers.filter(c => c && !c.deletedAt).map(curator => {
          if(curator) {
            const curatorName = (curator.id === this.state.currentUser.id) ? 'You' : curator.name;

            return (
              <a key={`curator_${curator.id}`} href="#" onClick={e => this.handleCuratorClick(curator.id, e)}><strong>{curatorName}</strong></a>
            );
          }
        });

        if(curatorLinks && curatorLinks.length) {
          if(profileCurators.length >= 2) {
            // intersperse separators in JSX nodes
            curatorLinks = curatorLinks.slice(1).reduce((xs, x, i) => {
              const separator = (i === (curatorLinks.length - 2)) ? ' and ' : ', ';

              return xs.concat([separator, x]);
            }, [curatorLinks[0]]);

            curatorsMessage = (
              <p className="help-block">{curatorLinks} curate this board.</p>
            );
          }
          else {
            const curateAction = `curate${(curatorUsers[0].id === this.state.currentUser.id) ? '' : 's'}`;

            curatorsMessage = (
              <p className="help-block">{curatorLinks[0]} {curateAction} this board.</p>
            );
          }
        }

        if(profileCurators.includes(this.state.currentUser.id)) {
          isCurator = isProfileCurator = true;
        }
      }
      else if(this.userCanCurate()) {
        // profile has no curators set, so all curators should see message
        isCurator = true;
      }
    }

    if(isCurator) {
      commentMessage = (
        <p className="help-block">
          As a curator{isProfileCurator ? ' of this profile' : ''}, you&apos;ll receive updates on
          your <a href="#" onClick={this.handleNotificationsClick}><strong>Notifications</strong></a> page about all new comments posted here.
        </p>
      );
    }
    else {
      commentMessage = (
        <p className="help-block">{profileCurators.length ? 'Profile curators' : 'Curators'} will be notified of comments posted on this {containerType}.</p>
      );
    }

    const uiModalContent = (
      <div className="profile-comment-modal">
        <h4 className="heading-dialog">Comment on this {containerType === 'profile' ? 'board' : containerType}</h4>
        {curatorsMessage}
        {commentMessage}
        <CommentBox
          user={this.state.currentUser}
          users={this.state.users}
          containerType={containerType.toLowerCase()}
          containerId={containerId}
          allowCommentsToggle={false}
          postHasAttachment={false}
          hideStat={true}
          hideFavorites={true}
          showNewestFirst={true} />
        <div className="row dialog-toolbar">
          <div className="col-sm-12"><div className="button u-w100" onClick={this.handleCloseProfileCommentClick}>Close</div></div>
        </div>
      </div>
    );

    // running .create with in use id's, will update the contents
    this.dialog.create({
      id: 'profile-comment-modal',
      content: uiModalContent,
      _wideMode: true
    });
  };

  //
  // / end comment modal
  //

  reloadPage = event => {
    this._preventDefault(event);

    window.location.reload();
  };

  renderToastMessages = () => {
    const toastMessages = (this.state.toastMessages || []).slice();

    if(_.isEmpty(toastMessages)) {
      return;
    }

    const toastMessageNodes = [];
    let errorMode = false;
    let infoMode = false;

    for(let i = 0; i < toastMessages.length; i++) {
      const toastMessage = toastMessages[i];

      if(!errorMode && toastMessage.isError) {
        errorMode = true;
      }
      else if(!infoMode && toastMessage.isInfo) {
        infoMode = true;
      }

      toastMessageNodes.push(
        <ToastMessage
          key={`toast_${i}`}
          onDismissClick={() => this.dequeueToastMessage(toastMessage.messageId)}
          {...toastMessage} />
      );
    }

    const toastMessageFlowClasses = classNames('toast-message-flow', {
      'toast-message-flow--error': errorMode,
      'toast-message-flow--info': infoMode
    });

    return (
      <div className={toastMessageFlowClasses}>
        {toastMessageNodes}
      </div>
    );
  };

  handleClosedMobileDownload = () => {
    putMobileBannerDismissedToLS();
    this.setState({didUpdateMobileBannerStatus: true});
  };

  getMobileAppDownloadInfo = () => {
    if(isAndroidBrowser()) {
      return {
        getItWhere: GET_FROM_PLAY_STORE_MESSAGE,
        link: PLAY_STORE_URL
      };
    }

    return {
      getItWhere: GET_FROM_APP_STORE_MESSAGE,
      link: APP_STORE_URL
    };
  };

  render() {
    const {appData = {}, joyride, location = {}} = this.props;
    const {state: locationState} = location;
    const {currentUser, currentCompany, users, digests, totalRivals, notificationsCount, uiShowTimeoutErrorMessage} = this.state;
    const {user, company, v2Host} = appData;
    // NOTE: state.rivals can contain temporary empty objects when fetching queued rival requests
    const rivals = this.state.rivals
      ? Object.values(this.state.rivals).slice().filter(r => !_.isEmpty(r)).sort((r1, r2) => r1.name.localeCompare(r2.name))
      : null;

    const rivalGroups = this.state.rivalGroups ? this.state.rivalGroups.slice() : null;
    const pathname = this.getCurrentLocation();
    const builderMode = pathname.includes('/battlecard/edit') || (locationState && locationState.builderMode);
    const newBattlecardMode = pathname.endsWith('/battlecard/edit/new');
    const battlecardMode = (pathname.includes('/battlecard') && !builderMode) || (locationState && locationState.battlecardId);
    const battlecardEmbedMode = pathname.includes('/battlecard/embed') && !builderMode;
    const isCurator = this.userCanCurate();
    const dashboardDefaults = this.getUIDefaults(uiDefaultTypes.DASHBOARD);
    const isCardEmbed = pathname.includes('/card/embed');
    const navigationRegion = !pathname.includes('/snapshot') && !battlecardEmbedMode && !isCardEmbed && (
      <Navigation
        rivalGroups={rivalGroups}
        notificationCounts={this.getNotificationCounts()}
        defaultGroupId={dashboardDefaults.activeGroupId} />
    );
    const {getItWhere, link} = this.getMobileAppDownloadInfo();
    const downloadMobileBanner = this.displayMobileDownloadBanner() && (
      <DownloadMobileBanner
        getItWhere={getItWhere}
        appLink={link}
        onViewPressed={this.handleClosedMobileDownload}
        onClosePressed={this.handleClosedMobileDownload} />
    );
    let appClasses = classNames('klue-app', {
      'user-curator': isCurator,
      'user-consumer': !isCurator
    });
    let timeoutMessageRegion;
    let joyrideRegion;

    if(_.isEmpty(appData) || _.isEmpty(currentUser) || _.isEmpty(currentCompany)) {
      return (
        <div className={appClasses}>
          <ErrorPage
            title="Something isn&apos;t configured right."
            body="Please check your application configuration and reload Klue." />
        </div>
      );
    }

    // base menu props
    const menuProps = {
      user: currentUser,
      company: currentCompany,
      isFeedOrProfile: false
    };

    // base route props
    const routeProps = {
      user: currentUser,
      company: currentCompany,
      users
    };

    const profileProps = {};

    // add custom props based on selected route here
    if(pathname.startsWith('/feed') || pathname.startsWith('/profile')) {
      _.extend(routeProps, {
        rivals,
        postsUrl: appData.postsUrl,
        logo: appData.logo,
        reloadUserCompany: this.loadCompany,
        onRemoveCardsFromBattlecards: this.removeCardsFromBattlecards,
        maxBattlecardCards: this._maxBattlecardCards,
        onTrackRecentProfileView: this.trackRecentProfileView,
        onEnqueueToastMessage: this.enqueueToastMessage,
        onClearToastMessages: this.clearToastMessages
      });

      _.extend(menuProps, {
        isFeedOrProfile: true
      });

      const profileParams = getRouteParams(this.props, '/profile/:profileId');
      const isEditing = (/(\/\d+\/)(\w*\/)*(edit|new)\b.*$/i).test(pathname) || builderMode || newBattlecardMode;

      if(pathname.startsWith('/profile') && profileParams.profileId) {
        if(redirectConsumersToV2({user, company, v2Host}) || redirectCuratorsToV2({user, company, v2Host})) {
          return null;
        }

        // profile
        _.extend(profileProps, {
          editMode: isCurator && isEditing,
          builderMode: isCurator && builderMode,
          newBattlecardMode: isCurator && newBattlecardMode,
          battlecardMode,
          embedMode: battlecardEmbedMode,
          onToggleCardOnBattlecard: this.toggleCardOnBattlecard,
          onToggleLane: this.toggleLane
        });

        appClasses = classNames(appClasses, {
          'section-profile': !profileProps.battlecardMode,
          'section-battlecard': profileProps.battlecardMode,
          'section-battlecard-embed': battlecardEmbedMode
        });
      }
      else {
        appClasses = classNames(appClasses, 'section-feed');

        _.extend(routeProps, {digests});
      }
    }
    else if(pathname.startsWith('/posts')) {
      _.extend(routeProps, {rivals});
    }
    else if(pathname.startsWith('/digest')) {
      // intel digest
      const digestParams = getRouteParams(this.props, '/digest/:digestId');
      let digestId = 0;

      if(digestParams) {
        digestId = parseInt(digestParams.digestId, 10) || 0;
      }

      appClasses = classNames(appClasses, 'section-digest');

      _.extend(routeProps, {
        digests,
        rivalGroups,
        editMode: (digestId > 0) || (pathname.endsWith('/digest') && isCurator),
        archivesMode: pathname.includes('/digest/archives') || (pathname.endsWith('/digest') && !isCurator),
        onEnqueueToastMessage: this.enqueueToastMessage,
        onClearToastMessages: this.clearToastMessages,
        // feed-related props
        rivals,
        postsUrl: appData.postsUrl
      });
    }
    else if(pathname.startsWith('/alerts')) {
      return redirectToV2({v2Host, v2Path: '/alerts'});
    }
    else if(pathname.startsWith('/monitors')) {
      return redirectToV2({v2Host, v2Path: '/monitors'});
    }
    else if(pathname.startsWith('/users')) {
      _.extend(routeProps, {rivals, rivalGroups});

      if(pathname === '/users') {
        _.extend(routeProps, {
          userInviteUrl: appData.userInviteUrl
        });
      }

      appClasses = classNames(appClasses, 'section-users');
    }
    else if(pathname.startsWith('/settings')) {
      appClasses += 'settings';
    }
    else if(pathname.startsWith('/notifications')) {
      appClasses = classNames(appClasses, 'section-dashboard section-dashboard-messages');

      _.extend(routeProps, {
        rivals,
        notificationsCount,
        onRefreshNotificationsCount: this.refreshNotificationsCount
      });
    }
    else if((pathname === '') || pathname.startsWith('/dashboard')) {
      if(pathname.startsWith('/dashboard') && redirectConsumersToV2({user, company, v2Host})) {
        return null;
      }

      appClasses = classNames(appClasses, 'section-dashboard');

      // include dashboard rival/group methods
      const {redirectCode = ''} = this.props.location.state || {};

      _.extend(routeProps, {
        messageId: redirectCode,
        rivals,
        rivalGroups,
        totalRivals,
        editMode: isCurator && pathname.endsWith('/edit'),
        onGetUIDefaults: this.getUIDefaults,
        onDisplayChange: this.handleDashboardDisplayChange,
        onEnqueueToastMessage: this.enqueueToastMessage,
        onClearToastMessages: this.clearToastMessages
      });
    }
    else if(pathname.startsWith('/search')) {
      if(redirectConsumersToV2({user, company, v2Host})) {
        return null;
      }

      _.extend(routeProps, {
        rivals: this.state.rivals || {}     // raw rivals object keyed by rival.id
      });
    }
    else if(pathname.startsWith('/answer')) {
      _.extend(routeProps, {
        rivals
      });
    }
    else if(pathname.startsWith('/card/embed')) {
      redirectToV2({v2Host});

      return null;
    }
    else {
      appClasses = classNames(appClasses, 'section-default');
    }

    if(uiShowTimeoutErrorMessage) {
      timeoutMessageRegion = (
        <div className="warning warning--timeout">
          <div className="alert alert-danger alert-dismissible">
            <div className="close" onClick={() => this.showAjaxTimeoutErrorMessage(false)}><span>&times;</span></div>
            <strong>Sorry, we&apos;re having some trouble communicating with Klue right now.</strong>
            {' '}Please check your connection and try again &mdash;
            {' '}<a href="#" className="alert-link" onClick={this.reloadPage}>Reload the page</a>
            <br /> If this problem persists, please contact us.
          </div>
        </div>
      );
    }

    if(!_.isEmpty(joyride)) {
      joyrideRegion = (
        <Joyride ref="joyride" {...this.props.joyride} />
      );
    }

    let homeRoute = '/dashboard';

    if(!_.isEmpty(appData) && appData.forceHomeRoute) {
      homeRoute = appData.forceHomeRoute;
    }

    const routeDefs = routes({isCurator, location});
    const redirectDefs = redirects({isCurator, location});

    return (
      <DndProvider backend={HTML5Backend}>
        <TagsProvider>
          <PostsProvider>
            <div className={appClasses}>
              <Dialogs callbackForMethods={this._dialogComponentSetCallbacks} />
              <ModalSingleCardView />
              {timeoutMessageRegion}
              {this.renderToastMessages()}
              {joyrideRegion}
              {navigationRegion}
              {downloadMobileBanner}
              <Switch>
                {routeDefs.map(({path, component: Component}) => {
                  // NOTE: static Route key used below to avoid re-rendering problems detailed here:
                  // https://github.com/ReactTraining/react-router/issues/4578
                  return (
                    <Route
                      key="route"
                      path={path}
                      render={props => (
                        <Component {...props} {...routeProps} {...profileProps} />
                      )} />
                  );
                })}
                {redirectDefs.map(fromTo => (<Redirect exact={true} key={Object.keys(fromTo).join('|')} {...fromTo} />))}
                <Redirect from="/" to={{...location, pathname: homeRoute}} />
                <Redirect path="*" to={{...location, pathname: '/'}} />
              </Switch>
            </div>
          </PostsProvider>
        </TagsProvider>
      </DndProvider>
    );
  }

}

export default withRouter(JoyrideConfig(AppBase));
